var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmusementParkContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4896_21522)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 166H600.5H900.25H1200V800H0V166Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 166H600.5H900.25H1200V800H0V166Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.135 126.088C289.664 115.303 284.203 105.33 276.253 97.381C265.125 86.2521 250.031 80 234.292 80C218.553 80 203.46 86.2521 192.331 97.381C188.111 101.6 184.593 106.39 181.85 111.569C173.815 107.072 164.693 104.65 155.321 104.65C140.914 104.65 127.097 110.373 116.91 120.56C107.262 130.208 101.618 143.112 101.048 156.689H101V158.971V166.731H573V158.971V156.689H572.867C572.356 152.323 570.39 148.23 567.251 145.091C563.57 141.41 558.577 139.342 553.371 139.342C548.531 139.342 543.875 141.13 540.286 144.34C537.58 135.698 532.815 127.75 526.294 121.229C515.678 110.613 501.281 104.65 486.269 104.65C471.257 104.65 456.859 110.613 446.244 121.229C441.086 126.387 437.026 132.438 434.215 139.019C433.114 137.528 431.897 136.112 430.57 134.785C423.551 127.766 414.03 123.822 404.103 123.822C394.175 123.822 384.654 127.766 377.635 134.785C375.113 137.307 372.989 140.151 371.301 143.221C368.611 141.883 365.624 141.168 362.563 141.168C360.86 141.168 359.179 141.39 357.56 141.816C355.464 137.58 352.677 133.672 349.271 130.267C341.053 122.048 329.907 117.431 318.284 117.431C308.809 117.431 299.649 120.5 292.135 126.088Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.249 112.03C818.922 97.5138 811.572 84.092 800.873 73.393C785.895 58.4147 765.58 50 744.397 50C723.215 50 702.9 58.4147 687.922 73.393C682.243 79.0721 677.507 85.5185 673.816 92.4885C663.001 86.4362 650.724 83.1769 638.111 83.1769C618.72 83.1769 600.124 90.8796 586.414 104.59C573.429 117.575 565.833 134.942 565.065 153.215H565V156.287V166.731H1200.26V153.215H1200.08C1199.4 147.34 1196.75 141.832 1192.53 137.607C1187.57 132.653 1180.85 129.869 1173.84 129.869C1167.33 129.869 1161.06 132.275 1156.23 136.595C1152.59 124.965 1146.18 114.267 1137.4 105.49C1123.11 91.2032 1103.74 83.1769 1083.53 83.1769C1063.33 83.1769 1043.95 91.2032 1029.66 105.49C1022.72 112.433 1017.26 120.577 1013.47 129.434C1011.99 127.427 1010.35 125.521 1008.57 123.736C999.12 114.288 986.306 108.98 972.945 108.98C959.584 108.98 946.77 114.288 937.322 123.736C933.928 127.129 931.069 130.957 928.798 135.088C925.177 133.288 921.156 132.326 917.036 132.326C914.744 132.326 912.482 132.624 910.303 133.198C907.482 127.497 903.731 122.237 899.148 117.654C888.087 106.593 873.085 100.379 857.442 100.379C844.689 100.379 832.362 104.51 822.249 112.03Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.173 167C165.78 169.917 165 173.182 165 176.63C165 188.984 175.015 199 187.37 199H419.63C431.984 199 442 188.984 442 176.63C442 173.182 441.22 169.917 439.827 167H167.173Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: 360,
    width: 278,
    height: 76,
    rx: 35.775,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 372,
    width: 198,
    height: 40,
    rx: 20,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 644.848,
    width: 293.839,
    height: 88.1516,
    rx: 44.0758,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.85,
    y: 679.13,
    width: 189.036,
    height: 39.1785,
    rx: 19.5893,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.961 515.989L747.99 538.676L643.961 576.857",
    stroke: "white",
    strokeWidth: 2.21337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.035 627.763L746.883 537.568V650.451",
    stroke: "white",
    strokeWidth: 2.21337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.837 628.317L750.756 541.995L852.018 571.876",
    stroke: "white",
    strokeWidth: 2.21337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.496 455.674L747.988 538.123L853.124 513.775",
    stroke: "white",
    strokeWidth: 2.21337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.375 456.781L747.99 539.229V431.88",
    stroke: "white",
    strokeWidth: 2.21337
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 747.436,
    cy: 538.122,
    r: 22.1337,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 747.436,
    cy: 538.122,
    r: 16.6003,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.052 557.02C749.841 555.821 750.764 554.723 751.981 554.723H752.614C753.481 554.723 754.245 555.292 754.492 556.123L796.486 697.181C796.86 698.437 795.919 699.699 794.609 699.699H776.747C775.796 699.699 774.982 699.015 774.818 698.078L750.052 557.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.819 557.02C745.03 555.821 744.107 554.723 742.89 554.723H742.257C741.39 554.723 740.626 555.292 740.379 556.123L698.385 697.181C698.011 698.437 698.952 699.699 700.262 699.699H718.124C719.075 699.699 719.889 699.015 720.053 698.078L744.819 557.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.776 623.337C791.311 623.337 828.225 586.424 828.225 540.889C828.225 495.354 791.311 458.441 745.776 458.441C700.241 458.441 663.328 495.354 663.328 540.889C663.328 586.424 700.241 623.337 745.776 623.337ZM745.776 617.804C788.255 617.804 822.691 583.368 822.691 540.889C822.691 498.41 788.255 463.974 745.776 463.974C703.297 463.974 668.861 498.41 668.861 540.889C668.861 583.368 703.297 617.804 745.776 617.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.436 653.217C809.167 653.217 859.211 603.173 859.211 541.441C859.211 479.71 809.167 429.666 747.436 429.666C685.704 429.666 635.66 479.71 635.66 541.441C635.66 603.173 685.704 653.217 747.436 653.217ZM747.435 645.715C805.024 645.715 851.709 599.03 851.709 541.442C851.709 483.853 805.024 437.168 747.435 437.168C689.846 437.168 643.161 483.853 643.161 541.442C643.161 599.03 689.846 645.715 747.435 645.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.285 604.896L803.024 610.946C801.144 612.513 800.057 614.834 800.057 617.282V636.617C800.057 641.172 803.749 644.864 808.303 644.864H823.105C827.66 644.864 831.352 641.172 831.352 636.617V617.345C831.352 614.859 830.23 612.505 828.299 610.94L820.758 604.825C817.698 602.344 813.311 602.374 810.285 604.896Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.781 622.092C806.781 619.036 809.259 616.559 812.315 616.559H830.852V633.989H812.315C809.259 633.989 806.781 631.512 806.781 628.455V622.092Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.67 634.777L734.409 640.828C732.529 642.395 731.441 644.716 731.441 647.163V666.498C731.441 671.053 735.134 674.745 739.688 674.745H754.49C759.045 674.745 762.737 671.053 762.737 666.498V647.227C762.737 644.741 761.615 642.387 759.684 640.821L752.143 634.707C749.083 632.226 744.696 632.255 741.67 634.777Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M738.166 651.974C738.166 648.918 740.643 646.44 743.699 646.44H762.236V663.871H743.699C740.643 663.871 738.166 661.393 738.166 658.337V651.974Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M671.949 607.109L664.688 613.16C662.808 614.727 661.721 617.048 661.721 619.495V638.831C661.721 643.385 665.413 647.077 669.968 647.077H684.769C689.324 647.077 693.016 643.385 693.016 638.831V619.559C693.016 617.073 691.895 614.719 689.963 613.153L682.422 607.039C679.362 604.558 674.975 604.587 671.949 607.109Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.445 624.306C668.445 621.25 670.923 618.772 673.979 618.772H692.516V636.203H673.979C670.923 636.203 668.445 633.725 668.445 630.669V624.306Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M633.215 558.415L625.954 564.466C624.073 566.033 622.986 568.354 622.986 570.801V590.137C622.986 594.691 626.679 598.383 631.233 598.383H646.035C650.59 598.383 654.282 594.691 654.282 590.137V570.865C654.282 568.379 653.16 566.025 651.229 564.459L643.688 558.345C640.628 555.864 636.241 555.893 633.215 558.415Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.711 575.612C629.711 572.556 632.188 570.078 635.244 570.078H653.781V587.508H635.244C632.188 587.508 629.711 585.031 629.711 581.975V575.612Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M633.215 483.16L625.954 489.21C624.073 490.777 622.986 493.098 622.986 495.546V514.881C622.986 519.436 626.679 523.128 631.233 523.128H646.035C650.59 523.128 654.282 519.436 654.282 514.881V495.609C654.282 493.123 653.16 490.77 651.229 489.204L643.688 483.089C640.628 480.608 636.241 480.638 633.215 483.16Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.711 500.356C629.711 497.3 632.188 494.823 635.244 494.823H653.781V512.253H635.244C632.188 512.253 629.711 509.776 629.711 506.72V500.356Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M671.949 427.825L664.688 433.876C662.808 435.443 661.721 437.764 661.721 440.211V459.547C661.721 464.101 665.413 467.793 669.968 467.793H684.769C689.324 467.793 693.016 464.101 693.016 459.547V440.275C693.016 437.789 691.895 435.435 689.963 433.869L682.422 427.755C679.362 425.274 674.975 425.303 671.949 427.825Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.445 445.022C668.445 441.966 670.923 439.488 673.979 439.488H692.516V456.918H673.979C670.923 456.918 668.445 454.441 668.445 451.385V445.022Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.806 489.8L839.545 495.851C837.665 497.418 836.578 499.739 836.578 502.186V521.522C836.578 526.076 840.27 529.768 844.825 529.768H859.627C864.181 529.768 867.874 526.076 867.874 521.522V502.25C867.874 499.764 866.752 497.41 864.821 495.844L857.28 489.73C854.22 487.249 849.833 487.278 846.806 489.8Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.303 506.997C843.303 503.941 845.78 501.463 848.836 501.463H867.373V518.894H848.836C845.78 518.894 843.303 516.416 843.303 513.36V506.997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.804 558.415L839.544 564.466C837.663 566.033 836.576 568.354 836.576 570.801V590.137C836.576 594.691 840.268 598.383 844.823 598.383H859.625C864.18 598.383 867.872 594.691 867.872 590.137V570.865C867.872 568.379 866.75 566.025 864.819 564.459L857.278 558.345C854.218 555.864 849.831 555.893 846.804 558.415Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.301 575.612C843.301 572.556 845.778 570.078 848.834 570.078H867.371V587.508H848.834C845.778 587.508 843.301 585.031 843.301 581.975V575.612Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M810.285 430.039L803.024 436.089C801.144 437.656 800.057 439.977 800.057 442.425V461.76C800.057 466.315 803.749 470.007 808.303 470.007H823.105C827.66 470.007 831.352 466.315 831.352 461.76V442.489C831.352 440.002 830.23 437.649 828.299 436.083L820.758 429.968C817.698 427.487 813.311 427.517 810.285 430.039Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.781 447.235C806.781 444.179 809.259 441.702 812.315 441.702H830.852V459.132H812.315C809.259 459.132 806.781 456.655 806.781 453.599V447.235Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.67 405.693L734.409 411.743C732.529 413.31 731.441 415.631 731.441 418.079V437.414C731.441 441.969 735.134 445.661 739.688 445.661H754.49C759.045 445.661 762.737 441.969 762.737 437.414V418.142C762.737 415.656 761.615 413.302 759.684 411.737L752.143 405.622C749.083 403.141 744.696 403.171 741.67 405.693Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_4896_21522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M738.166 422.889C738.166 419.833 740.643 417.356 743.699 417.356H762.236V434.786H743.699C740.643 434.786 738.166 432.309 738.166 429.253V422.889Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1199.74 799.774C1199.93 798.398 1200.03 796.993 1200.03 795.564C1200.03 778.865 1186.49 765.328 1169.79 765.328L1030.24 765.328C1013.54 765.328 1000 778.865 1000 795.564C1000 796.993 1000.1 798.398 1000.29 799.774L1199.74 799.774Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-42-outside-1_4896_21522",
    maskUnits: "userSpaceOnUse",
    x: 1040.41,
    y: 641.608,
    width: 111,
    height: 41,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1040.41,
    y: 641.608,
    width: 111,
    height: 41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 680.843C1150 675.822 1148.6 670.85 1145.87 666.211C1143.14 661.573 1139.14 657.357 1134.1 653.807C1129.06 650.257 1123.07 647.44 1116.48 645.519C1109.9 643.597 1102.84 642.608 1095.71 642.608C1088.58 642.608 1081.52 643.597 1074.93 645.519C1068.34 647.44 1062.36 650.257 1057.31 653.807C1052.27 657.357 1048.27 661.573 1045.55 666.211C1042.82 670.85 1041.41 675.822 1041.41 680.843L1095.71 680.843H1150Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1150 680.843C1150 675.822 1148.6 670.85 1145.87 666.211C1143.14 661.573 1139.14 657.357 1134.1 653.807C1129.06 650.257 1123.07 647.44 1116.48 645.519C1109.9 643.597 1102.84 642.608 1095.71 642.608C1088.58 642.608 1081.52 643.597 1074.93 645.519C1068.34 647.44 1062.36 650.257 1057.31 653.807C1052.27 657.357 1048.27 661.573 1045.55 666.211C1042.82 670.85 1041.41 675.822 1041.41 680.843L1095.71 680.843H1150Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 680.843C1150 675.822 1148.6 670.85 1145.87 666.211C1143.14 661.573 1139.14 657.357 1134.1 653.807C1129.06 650.257 1123.07 647.44 1116.48 645.519C1109.9 643.597 1102.84 642.608 1095.71 642.608C1088.58 642.608 1081.52 643.597 1074.93 645.519C1068.34 647.44 1062.36 650.257 1057.31 653.807C1052.27 657.357 1048.27 661.573 1045.55 666.211C1042.82 670.85 1041.41 675.822 1041.41 680.843L1095.71 680.843H1150Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-42-outside-1_4896_21522)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1093.41 642.937C1089.92 643.373 1086.49 644.239 1083.22 645.518C1078.31 647.44 1073.85 650.256 1070.09 653.807C1066.33 657.357 1063.35 661.572 1061.32 666.211C1059.28 670.85 1058.23 675.822 1058.23 680.843L1081.41 680.843C1081.17 678.847 1081.04 676.804 1081.04 674.726C1081.04 661.94 1085.85 650.512 1093.41 642.937Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1094.94 642.606C1098.43 643.042 1101.86 643.908 1105.13 645.188C1110.04 647.109 1114.5 649.925 1118.26 653.476C1122.02 657.026 1125 661.241 1127.04 665.88C1129.07 670.519 1130.12 675.491 1130.12 680.512L1106.94 680.512C1107.19 678.516 1107.31 676.474 1107.31 674.395C1107.31 661.609 1102.5 650.181 1094.94 642.606Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.59,
    y: 680.843,
    width: 4.58824,
    height: 42.8235,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1139.29,
    y: 680.843,
    width: 4.58824,
    height: 42.8235,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 722.137,
    width: 156,
    height: 6.11765,
    rx: 3.05882,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.27,
    y: 727.755,
    width: 123.353,
    height: 49.9412,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1111.77,
    y: 728.255,
    width: 12.2353,
    height: 48.9412,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.71,
    y: 728.255,
    width: 12.2353,
    height: 48.9412,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.82,
    y: 728.255,
    width: 12.2353,
    height: 48.9412,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.88,
    y: 728.255,
    width: 12.2353,
    height: 48.9412,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.94,
    y: 728.255,
    width: 12.2353,
    height: 48.9412,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1034.53,
    cy: 708.962,
    r: 7.91176,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1052.88,
    cy: 708.962,
    r: 7.91176,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.24,
    cy: 708.962,
    r: 7.91176,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.47 715.33C1064.24 714.68 1064.72 714 1065.41 714H1076.59C1077.28 714 1077.76 714.68 1077.53 715.33L1074.73 723.33C1074.59 723.731 1074.22 724 1073.79 724H1068.21C1067.78 724 1067.41 723.731 1067.27 723.33L1064.47 715.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.47 715.33C1046.24 714.68 1046.72 714 1047.41 714H1058.59C1059.28 714 1059.76 714.68 1059.53 715.33L1056.73 723.33C1056.59 723.731 1056.22 724 1055.79 724H1050.21C1049.78 724 1049.41 723.731 1049.27 723.33L1046.47 715.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.43 715.309C1028.22 714.663 1028.7 714 1029.38 714H1039.62C1040.3 714 1040.78 714.663 1040.57 715.309L1037.97 723.309C1037.84 723.721 1037.46 724 1037.02 724H1031.98C1031.54 724 1031.16 723.721 1031.03 723.309L1028.43 715.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 486.5C1104.6 486.5 1090.5 500.603 1090.5 518V555C1090.5 570.74 1077.74 583.5 1062 583.5H941C925.26 583.5 912.5 570.74 912.5 555V347C912.5 331.26 925.26 318.5 941 318.5H1157C1172.74 318.5 1185.5 331.26 1185.5 347V458C1185.5 473.74 1172.74 486.5 1157 486.5H1122ZM975.5 491C975.5 505.636 987.364 517.5 1002 517.5C1016.64 517.5 1028.5 505.636 1028.5 491V464C1028.5 448.26 1041.26 435.5 1057 435.5H1092.5C1107.41 435.5 1119.5 423.412 1119.5 408.5C1119.5 393.588 1107.41 381.5 1092.5 381.5H1007C989.603 381.5 975.5 395.603 975.5 413V491Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933 320.544V313.456C933 312.754 932.296 312.271 931.641 312.523L922.427 316.067C921.572 316.395 921.572 317.605 922.427 317.933L931.641 321.477C932.296 321.729 933 321.246 933 320.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 933,
    y: 311,
    width: 3,
    height: 43,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 956.75,
    y: 336.741,
    width: 4,
    height: 13,
    rx: 2,
    transform: "rotate(23.4369 956.75 336.741)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936 338H943C945.761 338 948 340.239 948 343V349C948 351.761 945.761 354 943 354H936V338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M933 342.743C933 341.891 932.012 341.441 931.401 342.035C926.258 347.035 923.292 353.374 923.02 360.002C922.998 360.553 923.448 361.001 924 361.001L957.5 361.001H991C991.552 361.001 992.002 360.553 991.979 360.002C991.679 352.673 988.084 345.698 981.895 340.495C976.501 335.961 969.504 334.82 962.024 334.566C961.463 334.547 961 335 961 335.561V352.001C961 352.554 960.552 353.001 960 353.001H934C933.448 353.001 933 352.554 933 352.001V342.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.425 352.266C983.993 345.721 977.296 341.854 973.195 340.319C972.688 340.129 972.129 340.408 972.053 340.944C971.757 343.032 972.588 346.095 977.719 346.667C981.059 347.039 984.414 349.851 987.12 352.988C987.895 353.887 989.09 353.249 988.425 352.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.928 351.642C927.028 349.257 928.494 347.386 929.687 346.211C930.088 345.817 930.744 345.891 930.938 346.418C931.355 347.549 931.263 349.161 929.018 350.311C928.347 350.655 927.758 351.228 927.245 351.94C926.547 352.911 925.428 352.727 925.928 351.642Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 921.5,
    y: 360.5,
    width: 73,
    height: 7,
    rx: 3.5,
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164 421.544V414.456C1164 413.754 1164.7 413.271 1165.36 413.523L1174.57 417.067C1175.43 417.395 1175.43 418.605 1174.57 418.933L1165.36 422.477C1164.7 422.729 1164 422.246 1164 421.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 43,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 1164 412)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 13,
    rx: 2,
    transform: "matrix(-0.917499 0.397738 0.397738 0.917499 1140.25 437.741)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161 439H1154C1151.24 439 1149 441.239 1149 444V450C1149 452.761 1151.24 455 1154 455H1161V439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1164 443.743C1164 442.891 1164.99 442.442 1165.6 443.035C1170.74 448.035 1173.71 454.374 1173.98 461.002C1174 461.554 1173.55 462.002 1173 462.002L1139.5 462.002H1106C1105.45 462.002 1105 461.554 1105.02 461.002C1105.32 453.674 1108.92 446.698 1115.1 441.496C1120.5 436.962 1127.5 435.821 1134.98 435.567C1135.54 435.548 1136 436 1136 436.562V453.002C1136 453.554 1136.45 454.002 1137 454.002H1163C1163.55 454.002 1164 453.554 1164 453.002V443.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.58 453.266C1113.01 446.721 1119.7 442.854 1123.81 441.319C1124.31 441.129 1124.87 441.408 1124.95 441.944C1125.24 444.032 1124.41 447.095 1119.28 447.667C1115.94 448.039 1112.59 450.851 1109.88 453.988C1109.1 454.887 1107.91 454.249 1108.58 453.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.07 452.642C1169.97 450.257 1168.51 448.386 1167.31 447.211C1166.91 446.817 1166.26 446.891 1166.06 447.418C1165.65 448.549 1165.74 450.161 1167.98 451.311C1168.65 451.655 1169.24 452.228 1169.75 452.94C1170.45 453.911 1171.57 453.727 1171.07 452.642Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 73,
    height: 7,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 1175 461)",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069 517.544V510.456C1069 509.754 1069.7 509.271 1070.36 509.523L1079.57 513.067C1080.43 513.395 1080.43 514.605 1079.57 514.933L1070.36 518.477C1069.7 518.729 1069 518.246 1069 517.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 43,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 1069 508)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 13,
    rx: 2,
    transform: "matrix(-0.917499 0.397738 0.397738 0.917499 1045.25 533.741)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 535H1059C1056.24 535 1054 537.239 1054 540V546C1054 548.761 1056.24 551 1059 551H1066V535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1069 539.743C1069 538.891 1069.99 538.442 1070.6 539.035C1075.74 544.035 1078.71 550.374 1078.98 557.002C1079 557.554 1078.55 558.002 1078 558.002L1044.5 558.002H1011C1010.45 558.002 1010 557.554 1010.02 557.002C1010.32 549.674 1013.92 542.698 1020.1 537.496C1025.5 532.962 1032.5 531.821 1039.98 531.567C1040.54 531.548 1041 532 1041 532.562V549.002C1041 549.554 1041.45 550.002 1042 550.002H1068C1068.55 550.002 1069 549.554 1069 549.002V539.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.58 549.266C1018.01 542.721 1024.7 538.854 1028.81 537.319C1029.31 537.129 1029.87 537.408 1029.95 537.944C1030.24 540.032 1029.41 543.095 1024.28 543.667C1020.94 544.039 1017.59 546.851 1014.88 549.988C1014.1 550.887 1012.91 550.249 1013.58 549.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.07 548.642C1074.97 546.257 1073.51 544.386 1072.31 543.211C1071.91 542.817 1071.26 542.891 1071.06 543.418C1070.65 544.549 1070.74 546.161 1072.98 547.311C1073.65 547.655 1074.24 548.228 1074.75 548.94C1075.45 549.911 1076.57 549.727 1076.07 548.642Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 73,
    height: 7,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 1080 557)",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599 415C599 401.193 587.807 390 574 390H424C410.193 390 399 401.193 399 415V445C399 458.807 387.807 470 374 470H324C310.193 470 299 481.193 299 495V545C299 558.807 310.193 570 324 570H550C563.807 570 575 558.807 575 545V514C575 507.373 580.373 502 587 502C593.627 502 599 496.627 599 490V415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.5,
    y: 321.5,
    width: 7,
    height: 161,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.5,
    y: 321.5,
    width: 9,
    height: 154,
    rx: 2.5,
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.5,
    y: 321.5,
    width: 7,
    height: 161,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.495 302.132C497.826 302.045 498.174 302.045 498.505 302.132L574.915 322.065C577.185 322.657 576.757 326 574.41 326H421.59C419.243 326 418.815 322.657 421.085 322.065L497.495 302.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 433.5,
    width: 33,
    height: 80,
    rx: 16.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.359,
    y: 394.372,
    width: 33,
    height: 113.545,
    rx: 16.5,
    transform: "rotate(-70.0162 441.359 394.372)",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.417,
    y: 330.283,
    width: 33,
    height: 120,
    rx: 16.5,
    transform: "rotate(68.5651 548.417 330.283)",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.542,
    y: 342.508,
    width: 35,
    height: 12,
    transform: "rotate(68.5651 514.542 342.508)",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.585,
    y: 358.587,
    width: 35,
    height: 12,
    transform: "rotate(68.5651 473.585 358.587)",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 497,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.417,
    y: 392.283,
    width: 33,
    height: 120,
    rx: 16.5,
    transform: "rotate(68.5651 548.417 392.283)",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.542,
    y: 404.508,
    width: 35,
    height: 12,
    transform: "rotate(68.5651 514.542 404.508)",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.585,
    y: 420.587,
    width: 35,
    height: 12,
    transform: "rotate(68.5651 473.585 420.587)",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 325.5C447 326.879 446.728 328.244 446.201 329.518C445.673 330.792 444.9 331.95 443.925 332.925C442.95 333.9 441.792 334.673 440.518 335.201C439.244 335.728 437.879 336 436.5 336C435.121 336 433.756 335.728 432.482 335.201C431.208 334.673 430.05 333.9 429.075 332.925C428.1 331.95 427.327 330.792 426.799 329.518C426.272 328.244 426 326.879 426 325.5L436.5 325.5H447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 325.5C531 326.879 530.728 328.244 530.201 329.518C529.673 330.792 528.9 331.95 527.925 332.925C526.95 333.9 525.792 334.673 524.518 335.201C523.244 335.728 521.879 336 520.5 336C519.121 336 517.756 335.728 516.482 335.201C515.208 334.673 514.05 333.9 513.075 332.925C512.1 331.95 511.327 330.792 510.799 329.518C510.272 328.244 510 326.879 510 325.5L520.5 325.5H531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 325.5C489 326.879 488.728 328.244 488.201 329.518C487.673 330.792 486.9 331.95 485.925 332.925C484.95 333.9 483.792 334.673 482.518 335.201C481.244 335.728 479.879 336 478.5 336C477.121 336 475.756 335.728 474.482 335.201C473.208 334.673 472.05 333.9 471.075 332.925C470.1 331.95 469.327 330.792 468.799 329.518C468.272 328.244 468 326.879 468 325.5L478.5 325.5H489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 325.5C573 326.879 572.728 328.244 572.201 329.518C571.673 330.792 570.9 331.95 569.925 332.925C568.95 333.9 567.792 334.673 566.518 335.201C565.244 335.728 563.879 336 562.5 336C561.121 336 559.756 335.728 558.482 335.201C557.208 334.673 556.05 333.9 555.075 332.925C554.1 331.95 553.327 330.792 552.799 329.518C552.272 328.244 552 326.879 552 325.5L562.5 325.5H573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 325.5C468 326.879 467.728 328.244 467.201 329.518C466.673 330.792 465.9 331.95 464.925 332.925C463.95 333.9 462.792 334.673 461.518 335.201C460.244 335.728 458.879 336 457.5 336C456.121 336 454.756 335.728 453.482 335.201C452.208 334.673 451.05 333.9 450.075 332.925C449.1 331.95 448.327 330.792 447.799 329.518C447.272 328.244 447 326.879 447 325.5L457.5 325.5H468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 325.5C552 326.879 551.728 328.244 551.201 329.518C550.673 330.792 549.9 331.95 548.925 332.925C547.95 333.9 546.792 334.673 545.518 335.201C544.244 335.728 542.879 336 541.5 336C540.121 336 538.756 335.728 537.482 335.201C536.208 334.673 535.05 333.9 534.075 332.925C533.1 331.95 532.327 330.792 531.799 329.518C531.272 328.244 531 326.879 531 325.5L541.5 325.5H552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 325.5C510 326.879 509.728 328.244 509.201 329.518C508.673 330.792 507.9 331.95 506.925 332.925C505.95 333.9 504.792 334.673 503.518 335.201C502.244 335.728 500.879 336 499.5 336C498.121 336 496.756 335.728 495.482 335.201C494.208 334.673 493.05 333.9 492.075 332.925C491.1 331.95 490.327 330.792 489.799 329.518C489.272 328.244 489 326.879 489 325.5L499.5 325.5H510Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 464,
    width: 10,
    height: 29,
    rx: 2,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 464,
    width: 10,
    height: 29,
    rx: 2,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 513,
    width: 135,
    height: 47,
    rx: 23.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.283 530.857V521.143C548.379 519.047 547.255 514.857 541.997 514.857C536.74 514.857 535.807 519.047 535.997 521.143V524.857",
    stroke: "#1E1E1E",
    strokeWidth: 1.22306,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.861 530.858V514.286C548.773 512.191 549.816 508 554.695 508C559.575 508 560.441 512.191 560.264 514.286V518",
    stroke: "#1E1E1E",
    strokeWidth: 1.22306,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.284 553.43C568.284 550.691 567.745 547.979 566.697 545.448C565.648 542.918 564.112 540.618 562.175 538.682C560.238 536.745 557.939 535.208 555.408 534.16C552.878 533.112 550.165 532.572 547.426 532.572C544.687 532.572 541.975 533.112 539.444 534.16C536.914 535.208 534.614 536.745 532.678 538.682C530.741 540.618 529.204 542.918 528.156 545.448C527.108 547.979 526.568 550.691 526.568 553.43L547.426 553.43H568.284Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.57,
    cy: 532.858,
    r: 2.57153,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.712 546.287C525.826 547.659 522.283 546.192 521.14 544.573C522.512 537.944 516.95 534.001 513.997 532.858C512.854 533.544 512.759 537.906 512.854 540.001C509.654 539.544 507.33 540.192 506.568 540.573C507.711 547.43 513.902 548.383 516.854 548.002C517.997 552.345 523.807 553.43 526.569 553.43H529.426L529.712 546.287Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.568,
    y: 553.145,
    width: 47.4304,
    height: 4.00016,
    rx: 2.00008,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 523,
    width: 66,
    height: 29,
    rx: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 494,
    width: 6,
    height: 47,
    rx: 3,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-117-outside-2_4896_21522",
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: 470.001,
    width: 84,
    height: 31,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 304,
    y: 470.001,
    width: 84,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.859 499.825C386.859 496.04 385.8 492.291 383.743 488.794C381.686 485.297 378.671 482.12 374.871 479.443C371.07 476.767 366.558 474.644 361.592 473.195C356.627 471.747 351.304 471.001 345.929 471.001C340.554 471.001 335.232 471.747 330.266 473.195C325.301 474.644 320.789 476.767 316.988 479.443C313.187 482.12 310.172 485.297 308.116 488.794C306.059 492.291 305 496.04 305 499.825L345.929 499.825H386.859Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.859 499.825C386.859 496.04 385.8 492.291 383.743 488.794C381.686 485.297 378.671 482.12 374.871 479.443C371.07 476.767 366.558 474.644 361.592 473.195C356.627 471.747 351.304 471.001 345.929 471.001C340.554 471.001 335.232 471.747 330.266 473.195C325.301 474.644 320.789 476.767 316.988 479.443C313.187 482.12 310.172 485.297 308.116 488.794C306.059 492.291 305 496.04 305 499.825L345.929 499.825H386.859Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.859 499.825C386.859 496.04 385.8 492.291 383.743 488.794C381.686 485.297 378.671 482.12 374.871 479.443C371.07 476.767 366.558 474.644 361.592 473.195C356.627 471.747 351.304 471.001 345.929 471.001C340.554 471.001 335.232 471.747 330.266 473.195C325.301 474.644 320.789 476.767 316.988 479.443C313.187 482.12 310.172 485.297 308.116 488.794C306.059 492.291 305 496.04 305 499.825L345.929 499.825H386.859Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    mask: "url(#path-117-outside-2_4896_21522)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.199 471C341.566 471.329 338.983 471.981 336.519 472.946C332.816 474.394 329.453 476.517 326.619 479.194C323.786 481.87 321.538 485.048 320.004 488.545C318.471 492.042 317.682 495.79 317.682 499.575L335.154 499.575C334.969 498.07 334.873 496.53 334.873 494.963C334.873 485.325 338.501 476.71 344.199 471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.354 471C347.987 471.329 350.569 471.981 353.034 472.946C356.736 474.394 360.1 476.517 362.934 479.194C365.767 481.87 368.015 485.048 369.548 488.545C371.082 492.042 371.871 495.79 371.871 499.575L354.399 499.575C354.584 498.07 354.68 496.53 354.68 494.963C354.68 485.325 351.051 476.71 345.354 471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 224,
    width: 159,
    height: 75.525,
    rx: 35.775,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658,
    y: 237,
    width: 82,
    height: 40,
    rx: 20,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.887 90.2537H705.959L713.01 250.405H688.836L695.887 90.2537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.319 241.711C680.593 240.888 681.363 240.333 682.23 240.333H719.616C720.483 240.333 721.253 240.888 721.527 241.711L725.221 252.79C725.655 254.095 724.684 255.442 723.309 255.442H678.537C677.162 255.442 676.191 254.095 676.626 252.79L680.319 241.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.135 146.156L700.924 73.634L661.642 193.496",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.391,
    y: 125.705,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 587.391 125.705)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.662,
    y: 170.998,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 650.662 170.998)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.314,
    y: 132.274,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 596.314 132.274)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.584,
    y: 177.566,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 659.584 177.566)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.236,
    y: 138.842,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 605.236 138.842)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.506,
    y: 184.417,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 668.506 184.417)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.16,
    y: 145.41,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 614.16 145.41)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 677.43,
    y: 190.986,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(36.3592 677.43 190.986)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.788 132.836C573.463 129.602 577.257 128.151 579.917 130.11L679.392 203.339C682.014 205.27 681.809 209.253 679.001 210.903L655.382 224.784C653.817 225.703 651.855 225.602 650.394 224.526L568.881 164.519C567.451 163.466 566.767 161.677 567.129 159.939L572.788 132.836Z",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.598,
    y: 138.19,
    width: 5.03622,
    height: 24.3663,
    rx: 2.51811,
    transform: "rotate(11.8701 576.598 138.19)",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.00724
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.576 197.949L701.941 73.1305L807.552 142.097",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722.477,
    y: 196.562,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 722.477 196.562)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.842,
    y: 147.504,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 783.842 147.504)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 731.131,
    y: 189.645,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 731.131 189.645)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.496,
    y: 140.586,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 792.496 140.586)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.783,
    y: 182.725,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 739.783 182.725)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 801.15,
    y: 133.667,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 801.15 133.667)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.438,
    y: 175.807,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 748.438 175.807)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809.805,
    y: 126.75,
    width: 5.03622,
    height: 17.1231,
    rx: 2.51811,
    transform: "rotate(-38.6408 809.805 126.75)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.965 212.22C723.019 210.732 722.6 206.695 725.178 204.633L821.658 127.502C824.2 125.47 827.991 126.699 828.858 129.835L836.152 156.242C836.635 157.99 836.03 159.857 834.614 160.99L755.554 224.194C754.168 225.302 752.264 225.5 750.681 224.7L725.965 212.22Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.00724
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732.12,
    y: 209.929,
    width: 5.03622,
    height: 24.3663,
    rx: 2.51811,
    transform: "rotate(-63.1299 732.12 209.929)",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.00724
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700.923,
    cy: 73.1304,
    r: 18.6304,
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700.923,
    cy: 73.1301,
    r: 9.06519,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.884 97.8022C696.89 97.5255 697.116 97.3043 697.393 97.3043C697.674 97.3043 697.902 97.5323 697.902 97.8135V231.29C697.902 232.39 697.01 233.282 695.91 233.282C694.792 233.282 693.893 232.363 693.918 231.246L696.884 97.8022Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.725 167C902.812 175.503 900 185.372 900 195.899C900 227.844 925.897 253.741 957.842 253.741H1128.22C1160.17 253.741 1186.06 227.844 1186.06 195.899C1186.06 185.372 1183.25 175.503 1178.34 167H907.725Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 927,
    y: 200,
    width: 234,
    height: 43,
    rx: 21.5,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.02 65.9818L1020.4 169.213",
    stroke: "white",
    strokeWidth: 1.82711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1012.18,
    y: 167.386,
    width: 12.7897,
    height: 7.30843,
    rx: 2.74066,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.68 180.846C1010.11 180.418 1010.69 180.177 1011.3 180.177H1022.19C1024.23 180.177 1025.25 182.637 1023.81 184.076C1023.38 184.504 1022.8 184.745 1022.19 184.745H1011.3C1009.26 184.745 1008.24 182.285 1009.68 180.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1021.31,
    y: 174.695,
    width: 0.913553,
    height: 5.48132,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.92,
    y: 174.695,
    width: 0.913553,
    height: 5.48132,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.22 63.6998L1071.1 169.672",
    stroke: "white",
    strokeWidth: 1.82711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.16,
    y: 167.387,
    width: 12.7897,
    height: 7.30843,
    rx: 2.74066,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.67 180.847C1063.09 180.419 1063.68 180.178 1064.28 180.178H1075.18C1077.21 180.178 1078.23 182.638 1076.79 184.077C1076.37 184.505 1075.78 184.746 1075.18 184.746H1064.28C1062.25 184.746 1061.23 182.286 1062.67 180.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074.3,
    y: 174.698,
    width: 0.913553,
    height: 5.48132,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1067.9,
    y: 174.698,
    width: 0.913553,
    height: 5.48132,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.49 64.61L1110.4 165.599",
    stroke: "white",
    strokeWidth: 1.82711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1104.15,
    y: 164.392,
    width: 12.7897,
    height: 7.30843,
    rx: 2.74066,
    transform: "rotate(-10.0913 1104.15 164.392)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.06 178.079C1104.4 177.582 1104.93 177.244 1105.53 177.138L1116.26 175.228C1118.26 174.872 1119.69 177.115 1118.53 178.784C1118.18 179.28 1117.65 179.619 1117.06 179.725L1106.33 181.635C1104.33 181.991 1102.89 179.748 1104.06 178.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.43,
    y: 169.987,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(-10.0913 1114.43 169.987)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1108.13,
    y: 171.105,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(-10.0913 1108.13 171.105)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.59 64.6111L1148.54 150.325",
    stroke: "white",
    strokeWidth: 1.82711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1142.21,
    y: 150.899,
    width: 12.7897,
    height: 7.30843,
    rx: 2.74066,
    transform: "rotate(-27.4793 1142.21 150.899)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.21 163.988C1146.39 163.411 1146.8 162.929 1147.33 162.65L1157 157.621C1158.81 156.682 1160.85 158.395 1160.23 160.335C1160.05 160.913 1159.65 161.394 1159.11 161.674L1149.44 166.702C1147.64 167.641 1145.6 165.929 1146.21 163.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1153.69,
    y: 153.167,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(-27.4793 1153.69 153.167)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.02,
    y: 156.117,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(-27.4793 1148.02 156.117)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.38 65.9809L980.627 164.044",
    stroke: "white",
    strokeWidth: 1.82711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.996,
    y: 160.48,
    width: 12.7897,
    height: 7.30843,
    rx: 2.74066,
    transform: "rotate(12.5149 972.996 160.48)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.644 173.079C968.155 172.754 968.774 172.645 969.365 172.776L980.004 175.138C981.99 175.579 982.452 178.201 980.736 179.294C980.225 179.619 979.605 179.728 979.014 179.597L968.375 177.236C966.389 176.795 965.927 174.172 967.644 173.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980.332,
    y: 169.594,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(12.5149 980.332 169.594)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 974.09,
    y: 168.209,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(12.5149 974.09 168.209)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.908 65.5242L941.359 150.285",
    stroke: "white",
    strokeWidth: 1.82711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 935.098,
    y: 144.656,
    width: 12.7897,
    height: 7.30843,
    rx: 2.74066,
    transform: "rotate(29.4212 935.098 144.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.31 155.153C926.893 154.991 927.517 155.066 928.045 155.364L937.537 160.717C939.309 161.717 938.989 164.36 937.029 164.906C936.445 165.069 935.821 164.993 935.293 164.696L925.801 159.343C924.029 158.343 924.35 155.7 926.31 155.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 939.463,
    y: 155.507,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(29.4212 939.463 155.507)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 933.893,
    y: 152.367,
    width: 0.913553,
    height: 5.48132,
    transform: "rotate(29.4212 933.893 152.367)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.54 23.7188C1046.1 23.4095 1046.77 23.4095 1047.32 23.7188L1137.22 73.9269C1138.87 74.8452 1138.22 77.3492 1136.33 77.3492H956.535C954.652 77.3492 954 74.8452 955.644 73.9269L1045.54 23.7188Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.52 23.2212L1056.99 77.3492H1034.05L1045.52 23.2212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.98 24.1361L1106.32 77.3506H1083.38L1045.98 24.1361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.06 23.6799L1005.83 77.3512H982.891L1045.06 23.6799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1043.24,
    y: 21.395,
    width: 6.39487,
    height: 3.65421,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1046.44,
    cy: 19.111,
    r: 4.11099,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1037.35,
    y: 77.8827,
    width: 16.8236,
    height: 118.195,
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.363,
    y: 196.619,
    width: 175.402,
    height: 6.39487,
    rx: 3.19744,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.655 201.627C956.148 200.79 957.046 200.276 958.017 200.276H1132.11C1133.08 200.276 1133.98 200.79 1134.47 201.627L1140.39 211.676C1141.46 213.503 1140.14 215.807 1138.02 215.807H952.106C949.987 215.807 948.669 213.503 949.744 211.676L955.655 201.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.918,
    y: 213.978,
    width: 209.204,
    height: 8.22198,
    rx: 4.11099,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.858,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1078.41,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012.63,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1144.18,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 979.745,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1111.3,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1045.52,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.301,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094.85,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.08,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.19,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127.74,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.97,
    cy: 218.088,
    r: 2.28388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.547 84.2515C966.471 85.3519 964.701 85.3519 963.626 84.2515L956.884 77.3507L974.289 77.3507L967.547 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.74 84.2515C1001.67 85.3519 999.897 85.3519 998.821 84.2515L992.079 77.3507L1009.48 77.3507L1002.74 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.384 84.2515C984.309 85.3519 982.539 85.3519 981.464 84.2515L974.721 77.3507L992.127 77.3507L985.384 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.58 84.2515C1019.5 85.3519 1017.73 85.3519 1016.66 84.2515L1009.92 77.3507L1027.32 77.3507L1020.58 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.37 84.2515C1037.3 85.3519 1035.53 85.3519 1034.45 84.2515L1027.71 77.3507L1045.11 77.3507L1038.37 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.63 84.2515C1108.55 85.3519 1106.78 85.3519 1105.71 84.2515L1098.96 77.3507L1116.37 77.3507L1109.63 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.21 84.2515C1055.13 85.3519 1053.36 85.3519 1052.29 84.2515L1045.55 77.3507L1062.95 77.3507L1056.21 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.57 84.2515C1072.49 85.3519 1070.72 85.3519 1069.65 84.2515L1062.9 77.3507L1080.31 77.3507L1073.57 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.46 84.2515C1126.39 85.3519 1124.62 85.3519 1123.54 84.2515L1116.8 77.3507L1134.21 77.3507L1127.46 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.4 84.2515C1090.33 85.3519 1088.56 85.3519 1087.48 84.2515L1080.74 77.3507L1098.15 77.3507L1091.4 84.2515Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 166,
    width: 71,
    height: 34,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 10,
    width: 3,
    height: 28,
    rx: 1.5,
    fill: "#22343C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.021 20.7777L52.5255 12.4422C51.8593 12.0307 51 12.51 51 13.293V25.2009C51 25.8571 51.6215 26.3355 52.2559 26.1676L65.7514 22.5952C66.6003 22.3705 66.7681 21.2391 66.021 20.7777Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3816 29.7859C48.7721 29.2897 49.3686 29 50 29C50.6314 29 51.2279 29.2897 51.6184 29.7859L92.6326 81.908C95.2136 85.1881 92.877 90 88.7032 90H11.2968C7.12295 90 4.78638 85.1881 7.36744 81.9081L48.3816 29.7859Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4187 32.0743L51.618 29.7859C51.2276 29.2897 50.631 29 49.9996 29C49.3682 29 48.7717 29.2897 48.3812 29.7859L7.36707 81.9081C4.78601 85.1881 7.12258 90 11.2964 90H31.7371L53.4187 32.0743Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-219-outside-3_4896_21522",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 74,
    width: 103,
    height: 128,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: 74,
    width: 103,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 76H15.85V89H28.72V76H43.57V89H56.44V76H71.29V89H85.15V76H100V89V102V200H76.24V149H76.1987C76.2261 148.504 76.24 148.003 76.24 147.5C76.24 132.864 64.4942 121 50.005 121C35.5158 121 23.77 132.864 23.77 147.5C23.77 148.003 23.7839 148.504 23.8113 149H23.77V200H1V102V89V76Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 76H15.85V89H28.72V76H43.57V89H56.44V76H71.29V89H85.15V76H100V89V102V200H76.24V149H76.1987C76.2261 148.504 76.24 148.003 76.24 147.5C76.24 132.864 64.4942 121 50.005 121C35.5158 121 23.77 132.864 23.77 147.5C23.77 148.003 23.7839 148.504 23.8113 149H23.77V200H1V102V89V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.85 76H17.85V74H15.85V76ZM1 76V74H-1V76H1ZM15.85 89H13.85V91H15.85V89ZM28.72 89V91H30.72V89H28.72ZM28.72 76V74H26.72V76H28.72ZM43.57 76H45.57V74H43.57V76ZM43.57 89H41.57V91H43.57V89ZM56.44 89V91H58.44V89H56.44ZM56.44 76V74H54.44V76H56.44ZM71.29 76H73.29V74H71.29V76ZM71.29 89H69.29V91H71.29V89ZM85.15 89V91H87.15V89H85.15ZM85.15 76V74H83.15V76H85.15ZM100 76H102V74H100V76ZM100 200V202H102V200H100ZM76.24 200H74.24V202H76.24V200ZM76.24 149H78.24V147H76.24V149ZM76.1987 149L74.2017 148.89L74.0851 151H76.1987V149ZM23.8113 149V151H25.9249L25.8083 148.89L23.8113 149ZM23.77 149V147H21.77V149H23.77ZM23.77 200V202H25.77V200H23.77ZM1 200H-1V202H1V200ZM15.85 74H1V78H15.85V74ZM17.85 89V76H13.85V89H17.85ZM28.72 87H15.85V91H28.72V87ZM26.72 76V89H30.72V76H26.72ZM43.57 74H28.72V78H43.57V74ZM45.57 89V76H41.57V89H45.57ZM56.44 87H43.57V91H56.44V87ZM54.44 76V89H58.44V76H54.44ZM71.29 74H56.44V78H71.29V74ZM73.29 89V76H69.29V89H73.29ZM85.15 87H71.29V91H85.15V87ZM87.15 89V76H83.15V89H87.15ZM85.15 78H100V74H85.15V78ZM98 76V89H102V76H98ZM98 89V102H102V89H98ZM102 200V102H98V200H102ZM76.24 202H100V198H76.24V202ZM74.24 149V200H78.24V149H74.24ZM76.1987 151H76.24V147H76.1987V151ZM74.24 147.5C74.24 147.967 74.2271 148.43 74.2017 148.89L78.1956 149.11C78.2251 148.577 78.24 148.04 78.24 147.5H74.24ZM50.005 123C63.3707 123 74.24 133.95 74.24 147.5H78.24C78.24 131.779 65.6177 119 50.005 119V123ZM25.77 147.5C25.77 133.95 36.6393 123 50.005 123V119C34.3923 119 21.77 131.779 21.77 147.5H25.77ZM25.8083 148.89C25.7829 148.43 25.77 147.967 25.77 147.5H21.77C21.77 148.04 21.7849 148.577 21.8144 149.11L25.8083 148.89ZM23.77 151H23.8113V147H23.77V151ZM25.77 200V149H21.77V200H25.77ZM1 202H23.77V198H1V202ZM-1 102V200H3V102H-1ZM-1 89V102H3V89H-1ZM-1 76V89H3V76H-1Z",
    fill: "#1E1E1E",
    mask: "url(#path-219-outside-3_4896_21522)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 76H28.72V89H15.85V76H1V89V102V200H23.77V149H23.8113C23.7839 148.504 23.77 148.003 23.77 147.5C23.77 138.95 27.7782 131.347 34 126.501V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.135 759.357C188.664 748.572 183.203 738.599 175.253 730.65C164.125 719.521 149.031 713.269 133.292 713.269C117.553 713.269 102.46 719.521 91.3307 730.65C87.1112 734.87 83.5927 739.659 80.8503 744.838C72.8147 740.341 63.6927 737.919 54.3211 737.919C39.9142 737.919 26.0975 743.642 15.9103 753.829C6.26234 763.477 0.618395 776.381 0.0479208 789.958H0V792.24V800H472V792.24V789.958H471.867C471.356 785.592 469.39 781.5 466.251 778.361C462.57 774.68 457.577 772.612 452.371 772.612C447.531 772.612 442.875 774.399 439.286 777.609C436.58 768.968 431.815 761.019 425.294 754.498C414.678 743.883 400.281 737.919 385.269 737.919C370.257 737.919 355.859 743.883 345.244 754.498C340.086 759.656 336.026 765.707 333.215 772.288C332.114 770.797 330.897 769.381 329.57 768.055C322.551 761.035 313.03 757.091 303.103 757.091C293.175 757.091 283.654 761.035 276.635 768.055C274.113 770.576 271.989 773.42 270.301 776.49C267.611 775.152 264.624 774.437 261.563 774.437C259.86 774.437 258.179 774.659 256.56 775.086C254.464 770.849 251.677 766.941 248.271 763.536C240.053 755.317 228.907 750.701 217.284 750.701C207.809 750.701 198.649 753.769 191.135 759.357Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5625 612.994V770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0391 597.474L62.0391 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5137 594.735L88.5137 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.99 606.604L114.99 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 564L141.466 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 552L167.942 770.024",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 587L194.418 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.895 603.865L220.895 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.369 606.604L247.369 784.631",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 613L273.845 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 712L300.321 770.023",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 712L327 771",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 712L353 771",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 715L380 772",
    stroke: "white",
    strokeWidth: 0.912959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 765.267V662.103C12.4346 639.735 29.2634 595 77.1025 595C124.942 595 141.77 639.735 144.205 662.103C145.27 678.536 156.621 711.402 193.505 711.402C230.388 711.402 243.261 678.079 242.805 662.103C242.348 646.126 232.945 634.714 215.416 634.714C197.887 634.714 188.94 646.126 188.027 662.103C187.114 678.079 197.157 711.402 237.327 711.402C287.54 711.402 323.602 711.122 361.489 711.122C375.64 711.122 395.725 723.447 395.725 745.358C395.725 767.269 395.725 760.093 395.725 765.267",
    stroke: "white",
    strokeWidth: 4.5648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 769V665.997C14.411 643.665 31.0774 599 78.4544 599C125.831 599 142.498 643.665 144.909 665.997C145.964 682.405 157.205 715.22 193.733 715.22C230.26 715.22 243.008 681.949 242.556 665.997C242.104 650.046 232.791 638.651 215.432 638.651C198.072 638.651 189.212 650.046 188.308 665.997C187.404 681.949 197.349 715.22 237.131 715.22C286.859 715.22 322.573 714.976 360.095 714.976C374.109 714.976 394 727.281 394 749.158C394 771.035 394 763.835 394 769",
    stroke: "white",
    strokeWidth: 4.5648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7773 748.998C76.909 736.189 100.66 713.5 113.304 688.612C134.221 647.44 121.252 550 160.576 550C191 550 187.767 603.981 209.939 603.981C227.677 603.981 241.035 603.981 245.498 603.981C261.394 605.506 293.188 614.96 293.188 656.132C293.188 733.444 323.308 761.807 365.141 761.807",
    stroke: "white",
    strokeWidth: 4.5648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 753.179C78.9554 740.359 102.362 717.649 114.822 692.739C135.435 651.529 122.655 554 161.407 554C191.389 554 188.203 608.03 210.053 608.03C227.533 608.03 240.697 608.03 245.095 608.03C260.76 609.557 292.092 619.019 292.092 660.229C292.092 737.611 321.774 766 363 766",
    stroke: "white",
    strokeWidth: 4.5648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.9922,
    y: 577.237,
    width: 4.5648,
    height: 7.30368,
    rx: 1.82592,
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-242-inside-4_4896_21522",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3507 581.267C68.3507 580.554 67.7729 579.976 67.0603 579.976H66.4686C62.772 579.976 59.7754 582.973 59.7754 586.669C59.7754 590.366 62.772 593.363 66.4686 593.363H84.1228C87.8194 593.363 90.816 590.366 90.816 586.669C90.816 582.973 87.8194 579.976 84.1228 579.976C83.4795 579.976 82.958 580.498 82.958 581.141V581.267C82.958 581.979 82.3803 582.557 81.6676 582.557H69.6411C68.9284 582.557 68.3507 581.979 68.3507 581.267Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3507 581.267C68.3507 580.554 67.7729 579.976 67.0603 579.976H66.4686C62.772 579.976 59.7754 582.973 59.7754 586.669C59.7754 590.366 62.772 593.363 66.4686 593.363H84.1228C87.8194 593.363 90.816 590.366 90.816 586.669C90.816 582.973 87.8194 579.976 84.1228 579.976C83.4795 579.976 82.958 580.498 82.958 581.141V581.267C82.958 581.979 82.3803 582.557 81.6676 582.557H69.6411C68.9284 582.557 68.3507 581.979 68.3507 581.267Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4686 580.976H67.0603V578.976H66.4686V580.976ZM60.7754 586.669C60.7754 583.525 63.3243 580.976 66.4686 580.976V578.976C62.2197 578.976 58.7754 582.421 58.7754 586.669H60.7754ZM66.4686 592.363C63.3243 592.363 60.7754 589.814 60.7754 586.669H58.7754C58.7754 590.918 62.2197 594.363 66.4686 594.363V592.363ZM84.1228 592.363H66.4686V594.363H84.1228V592.363ZM89.816 586.669C89.816 589.814 87.2671 592.363 84.1228 592.363V594.363C88.3717 594.363 91.816 590.918 91.816 586.669H89.816ZM84.1228 580.976C87.2671 580.976 89.816 583.525 89.816 586.669H91.816C91.816 582.421 88.3717 578.976 84.1228 578.976V580.976ZM81.958 581.141V581.267H83.958V581.141H81.958ZM81.6676 581.557H69.6411V583.557H81.6676V581.557ZM69.6411 581.557C69.4807 581.557 69.3507 581.427 69.3507 581.267H67.3507C67.3507 582.532 68.3761 583.557 69.6411 583.557V581.557ZM81.958 581.267C81.958 581.427 81.828 581.557 81.6676 581.557V583.557C82.9326 583.557 83.958 582.532 83.958 581.267H81.958ZM84.1228 578.976C82.9272 578.976 81.958 579.945 81.958 581.141H83.958C83.958 581.05 84.0318 580.976 84.1228 580.976V578.976ZM67.0603 580.976C67.2207 580.976 67.3507 581.106 67.3507 581.267H69.3507C69.3507 580.002 68.3252 578.976 67.0603 578.976V580.976Z",
    fill: "white",
    mask: "url(#path-242-inside-4_4896_21522)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.904,
    cy: 593.671,
    r: 1.82592,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.5994,
    cy: 593.671,
    r: 1.82592,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5341 587.737C89.4472 583.172 87.0125 582.259 86.2517 581.803C84.8822 580.89 83.4432 582.87 85.3387 583.628C87.6209 584.541 85.9424 586.205 86.7083 587.736C87.1648 588.649 88.3819 588.498 88.5341 587.737Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.02,
    y: 581.498,
    width: 4.5648,
    height: 7.30368,
    rx: 1.82592,
    transform: "rotate(24.0396 103.02 581.498)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-248-inside-5_4896_21522",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.706 585.325C101.996 584.674 101.704 583.911 101.053 583.621L100.513 583.38C97.1371 581.874 93.1797 583.39 91.6738 586.766C90.168 590.142 91.6839 594.099 95.0598 595.605L111.183 602.797C114.559 604.303 118.516 602.787 120.022 599.411C121.528 596.035 120.012 592.077 116.636 590.572C116.049 590.31 115.36 590.573 115.098 591.161L115.046 591.276C114.756 591.927 113.993 592.219 113.342 591.929L102.359 587.03C101.708 586.739 101.416 585.976 101.706 585.325Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.706 585.325C101.996 584.674 101.704 583.911 101.053 583.621L100.513 583.38C97.1371 581.874 93.1797 583.39 91.6738 586.766C90.168 590.142 91.6839 594.099 95.0598 595.605L111.183 602.797C114.559 604.303 118.516 602.787 120.022 599.411C121.528 596.035 120.012 592.077 116.636 590.572C116.049 590.31 115.36 590.573 115.098 591.161L115.046 591.276C114.756 591.927 113.993 592.219 113.342 591.929L102.359 587.03C101.708 586.739 101.416 585.976 101.706 585.325Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.098 591.161L114.184 590.754L115.098 591.161ZM100.106 584.293L100.646 584.534L101.46 582.707L100.92 582.467L100.106 584.293ZM92.5871 587.173C93.8679 584.302 97.2341 583.012 100.106 584.293L100.92 582.467C97.0401 580.736 92.4914 582.478 90.7605 586.358L92.5871 587.173ZM95.4672 594.692C92.5957 593.411 91.3062 590.045 92.5871 587.173L90.7605 586.358C89.0297 590.239 90.7722 594.787 94.6525 596.518L95.4672 594.692ZM111.59 601.884L95.4672 594.692L94.6525 596.518L110.775 603.71L111.59 601.884ZM119.109 599.003C117.828 601.875 114.462 603.164 111.59 601.884L110.775 603.71C114.656 605.441 119.205 603.698 120.935 599.818L119.109 599.003ZM116.229 591.485C119.1 592.766 120.39 596.132 119.109 599.003L120.935 599.818C122.666 595.938 120.924 591.389 117.043 589.658L116.229 591.485ZM114.184 590.754L114.133 590.868L115.96 591.683L116.011 591.568L114.184 590.754ZM113.749 591.016L102.766 586.117L101.952 587.943L112.934 592.842L113.749 591.016ZM102.766 586.117C102.62 586.051 102.554 585.879 102.619 585.733L100.793 584.918C100.277 586.073 100.796 587.428 101.952 587.943L102.766 586.117ZM114.133 590.868C114.068 591.015 113.896 591.081 113.749 591.016L112.934 592.842C114.09 593.357 115.444 592.839 115.96 591.683L114.133 590.868ZM117.043 589.658C115.951 589.171 114.671 589.662 114.184 590.754L116.011 591.568C116.048 591.485 116.146 591.448 116.229 591.485L117.043 589.658ZM100.646 584.534C100.792 584.599 100.858 584.771 100.793 584.918L102.619 585.733C103.135 584.577 102.616 583.223 101.46 582.707L100.646 584.534Z",
    fill: "white",
    mask: "url(#path-248-inside-5_4896_21522)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.1581,
    cy: 596.878,
    r: 1.82592,
    transform: "rotate(24.0396 97.1581 596.878)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.666,
    cy: 602.457,
    r: 1.82592,
    transform: "rotate(24.0396 109.666 602.457)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.502 599.456C120.196 595.659 118.344 593.833 117.835 593.106C116.957 591.715 114.835 592.938 116.258 594.402C117.97 596.165 115.76 597.001 115.835 598.712C115.88 599.731 117.053 600.089 117.502 599.456Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1074,
    y: 590.07,
    width: 4.5648,
    height: 7.30368,
    rx: 1.82592,
    transform: "rotate(-28.8299 34.1074 590.07)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-254-inside-6_4896_21522",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3651 593.427C36.0215 592.802 35.2368 592.575 34.6126 592.918L34.0941 593.204C30.8557 594.986 29.6755 599.057 31.458 602.295C33.2405 605.533 37.3107 606.714 40.5491 604.931L56.0152 596.418C59.2536 594.635 60.4338 590.565 58.6513 587.327C56.8688 584.088 52.7986 582.908 49.5602 584.691C48.9966 585.001 48.7912 585.709 49.1014 586.273L49.1619 586.383C49.5055 587.007 49.278 587.792 48.6538 588.135L38.1175 593.935C37.4933 594.278 36.7087 594.051 36.3651 593.427Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3651 593.427C36.0215 592.802 35.2368 592.575 34.6126 592.918L34.0941 593.204C30.8557 594.986 29.6755 599.057 31.458 602.295C33.2405 605.533 37.3107 606.714 40.5491 604.931L56.0152 596.418C59.2536 594.635 60.4338 590.565 58.6513 587.327C56.8688 584.088 52.7986 582.908 49.5602 584.691C48.9966 585.001 48.7912 585.709 49.1014 586.273L49.1619 586.383C49.5055 587.007 49.278 587.792 48.6538 588.135L38.1175 593.935C37.4933 594.278 36.7087 594.051 36.3651 593.427Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5763 594.08L35.0948 593.795L34.1304 592.042L33.6118 592.328L34.5763 594.08ZM32.334 601.813C30.8179 599.058 31.8217 595.596 34.5763 594.08L33.6118 592.328C29.8896 594.377 28.5331 599.055 30.5819 602.777L32.334 601.813ZM40.0669 604.055C37.3123 605.571 33.8502 604.567 32.334 601.813L30.5819 602.777C32.6308 606.499 37.3091 607.856 41.0313 605.807L40.0669 604.055ZM55.533 595.542L40.0669 604.055L41.0313 605.807L56.4974 597.294L55.533 595.542ZM57.7752 587.809C59.2914 590.564 58.2875 594.026 55.533 595.542L56.4974 597.294C60.2196 595.245 61.5762 590.567 59.5273 586.845L57.7752 587.809ZM50.0424 585.567C52.7969 584.051 56.259 585.055 57.7752 587.809L59.5273 586.845C57.4785 583.122 52.8002 581.766 49.078 583.815L50.0424 585.567ZM48.2254 586.755L48.2859 586.865L50.038 585.901L49.9775 585.791L48.2254 586.755ZM48.1716 587.259L37.6353 593.059L38.5997 594.811L49.136 589.011L48.1716 587.259ZM37.6353 593.059C37.4949 593.136 37.3184 593.085 37.2411 592.944L35.489 593.909C36.0989 595.017 37.4917 595.421 38.5997 594.811L37.6353 593.059ZM48.2859 586.865C48.3631 587.005 48.312 587.182 48.1716 587.259L49.136 589.011C50.2441 588.401 50.6479 587.009 50.038 585.901L48.2859 586.865ZM49.078 583.815C48.0306 584.391 47.6489 585.708 48.2254 586.755L49.9775 585.791C49.9336 585.711 49.9627 585.611 50.0424 585.567L49.078 583.815ZM35.0948 593.795C35.2352 593.717 35.4117 593.768 35.489 593.909L37.2411 592.944C36.6312 591.836 35.2385 591.432 34.1304 592.042L35.0948 593.795Z",
    fill: "white",
    mask: "url(#path-254-inside-6_4896_21522)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.8316,
    cy: 604.026,
    r: 1.82592,
    transform: "rotate(-28.8299 42.8316 604.026)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.8297,
    cy: 597.422,
    r: 1.82592,
    transform: "rotate(-28.8299 54.8297 597.422)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1663 589.363C55.765 584.923 53.1919 585.298 52.3053 585.265C50.6653 585.125 50.3599 587.555 52.3859 587.305C54.8253 587.004 54.1571 589.27 55.5667 590.243C56.4069 590.823 57.3999 590.103 57.1663 589.363Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.237 778.411C99.9279 772.698 97.0354 767.416 92.8249 763.206C86.9304 757.312 78.9357 754 70.5996 754C62.2635 754 54.2688 757.312 48.3743 763.206C46.1393 765.441 44.2757 767.978 42.8231 770.721C38.567 768.339 33.7355 767.056 28.7718 767.056C21.141 767.056 13.8228 770.088 8.42706 775.483C3.31699 780.593 0.327627 787.428 0.025395 794.619H0V795.828V799.938H250V794.619H249.929C249.659 792.307 248.617 790.139 246.955 788.477C245.005 786.527 242.361 785.432 239.603 785.432C237.04 785.432 234.574 786.378 232.673 788.078C231.24 783.501 228.715 779.291 225.262 775.837C219.639 770.215 212.013 767.056 204.062 767.056C196.111 767.056 188.485 770.215 182.862 775.837C180.13 778.57 177.98 781.775 176.491 785.26C175.908 784.471 175.263 783.721 174.561 783.018C170.843 779.3 165.8 777.211 160.542 777.211C155.284 777.211 150.241 779.3 146.523 783.018C145.187 784.353 144.062 785.86 143.168 787.485C141.743 786.777 140.161 786.398 138.54 786.398C137.637 786.398 136.747 786.516 135.89 786.742C134.779 784.498 133.303 782.428 131.5 780.624C127.147 776.272 121.243 773.826 115.087 773.826C110.068 773.826 105.217 775.452 101.237 778.411Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2891,
    y: 268.159,
    width: 2.65217,
    height: 58.3478,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.912,
    y: 268.159,
    width: 2.65217,
    height: 68.9565,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 217,
    width: 6,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 215.5,
    rx: 5,
    ry: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2246,
    y: 270.312,
    width: 25.7536,
    height: 107.087,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.377,
    y: 270.812,
    width: 6.18841,
    height: 106.087,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.754,
    y: 270.812,
    width: 6.18841,
    height: 106.087,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4492,
    y: 376.899,
    width: 126.42,
    height: 5.30435,
    rx: 2.65217,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4491 380.948C34.8474 380.096 35.7032 379.551 36.6442 379.551H161.79C162.73 379.551 163.586 380.096 163.985 380.948L168.33 390.247C169.081 391.854 167.908 393.696 166.135 393.696H32.2988C30.5256 393.696 29.353 391.854 30.1037 390.247L34.4491 380.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.0723,
    y: 391.927,
    width: 151.174,
    height: 7.07246,
    rx: 3.53623,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.4927,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.086,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.231,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.827,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.3619,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.956,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.102,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.8697,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.463,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7251,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.856,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.333,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.594,
    cy: 395.464,
    r: 1.76812,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6655 276.309C42.6955 277.556 40.8105 277.556 39.8405 276.309L35.5646 270.812L47.9414 270.812L43.6655 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3042 276.309C68.3342 277.556 66.4492 277.556 65.4791 276.309L61.2033 270.812L73.5801 270.812L69.3042 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9272 276.309C55.9572 277.556 54.0722 277.556 53.1022 276.309L48.8263 270.812L61.2031 270.812L56.9272 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0707 276.534C81.1021 277.697 79.3167 277.697 78.3481 276.534L73.579 270.812L86.8398 270.812L82.0707 276.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9409 276.309C93.9709 277.556 92.0859 277.556 91.1159 276.309L86.84 270.812L99.2168 270.812L94.9409 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.216 276.309C145.246 277.556 143.361 277.556 142.391 276.309L138.115 270.812L150.492 270.812L146.216 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58 276.309C119.61 277.556 117.725 277.556 116.755 276.309L112.479 270.812L124.855 270.812L120.58 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.478 276.309C158.508 277.556 156.623 277.556 155.653 276.309L151.377 270.812L163.754 270.812L159.478 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.957 276.309C131.987 277.556 130.102 277.556 129.131 276.309L124.856 270.812L137.232 270.812L132.957 276.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.289,
    y: 268.159,
    width: 2.65217,
    height: 76.913,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.909 314.161C132.65 313.096 132.552 311.691 133.397 311.205C134.203 310.741 134.432 312.052 134.449 313.317C134.821 313.208 135.233 313.165 135.711 313.219C135.9 312.056 136.268 310.835 136.883 311.001C137.5 311.168 137.448 312.485 137.251 313.649C137.365 313.697 137.483 313.749 137.603 313.805C138.046 314.012 138.42 314.335 138.726 314.715C141.804 318.536 147.365 325.185 148.204 325.185H164.954C165.321 325.185 165.685 325.237 166.033 325.356C166.719 325.589 167.565 325.914 168.346 326.289C169.494 326.84 170.503 327.499 170.66 328.13C170.72 328.37 170.859 328.718 171.032 329.154C171.372 330.008 171.846 331.201 172.133 332.59C172.539 334.562 172.566 336.929 171.287 339.279C170.92 339.953 170.66 340.691 170.66 341.458V352.852C170.66 353.837 169.862 354.635 168.877 354.635H168.596C167.469 354.635 166.686 353.521 167.42 352.666C167.767 352.262 168.083 351.738 168.083 351.206V341.567C168.083 340.855 167.506 340.278 166.795 340.278C166.083 340.278 165.506 340.855 165.506 341.567V352.698C165.506 353.768 164.639 354.635 163.569 354.635C162.309 354.635 161.356 353.433 161.88 352.287C162.097 351.812 162.333 351.436 162.561 351.322C162.993 351.106 162.924 347.187 162.759 343.708C162.668 341.775 161.06 340.278 159.125 340.278H150.413C148.38 340.278 146.732 341.926 146.732 343.959V352.645C146.732 353.744 145.841 354.635 144.742 354.635C143.486 354.635 142.505 353.401 143.336 352.459C143.472 352.305 143.622 352.168 143.787 352.058C144.373 351.667 144.343 351.039 144.149 350.517C143.974 350.046 143.558 349.725 143.152 349.429C142.052 348.628 140.174 346.953 138.265 344.328C135.972 341.175 138.81 338.915 140.528 337.548C141.017 337.159 141.415 336.842 141.578 336.597C142.02 335.934 140.473 332.886 138.927 329.838C137.897 327.806 136.866 325.774 136.424 324.448C135.958 323.051 135.472 322.684 135.062 322.775C134.6 322.877 134.263 323.228 133.922 323.582C133.655 323.859 133.386 324.139 133.053 324.303C130.566 325.527 126.987 327.043 126.485 326.289C126.252 325.941 126.02 325.775 125.834 325.643C125.43 325.356 125.244 325.224 125.748 323.712C126.485 321.503 129.061 316.35 131.27 315.245C131.805 314.978 132.253 314.646 132.683 314.327C132.759 314.271 132.834 314.216 132.909 314.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.641 342.99L143.113 341.885V345.199L141.641 342.99Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.714 317.368L130.007 317.075C130.32 316.761 130.288 316.245 129.939 315.973L123.971 311.331L128.612 317.299C128.884 317.649 129.401 317.681 129.714 317.368Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.053 315.465C141.777 315.063 141.246 314.634 140.685 314.267C140.109 313.891 139.436 313.539 138.821 313.31C138.382 313.147 137.866 313.144 137.453 313.327C137.241 313.42 137.036 313.571 136.898 313.797C136.756 314.029 136.71 314.302 136.76 314.586C136.893 315.343 137.448 316.253 138.139 317.159C138.847 318.087 139.758 319.087 140.696 320.037C142.57 321.938 144.588 323.679 145.393 324.304C145.885 324.686 146.344 324.934 146.806 325.034C147.28 325.136 147.714 325.073 148.131 324.911C148.534 324.754 148.931 324.502 149.34 324.222C149.478 324.128 149.617 324.03 149.761 323.93C150.06 323.72 150.38 323.497 150.748 323.259C151.031 323.075 151.257 322.904 151.402 322.74C151.472 322.66 151.559 322.543 151.598 322.393C151.646 322.213 151.616 322.008 151.478 321.843C151.366 321.709 151.22 321.65 151.129 321.621C151.028 321.59 150.923 321.575 150.827 321.567C150.633 321.55 150.401 321.557 150.163 321.573C149.752 321.601 149.255 321.662 148.778 321.722C148.701 321.731 148.625 321.741 148.549 321.75C147.99 321.819 147.494 321.875 147.163 321.875C147.125 321.875 147.013 321.851 146.81 321.717C146.617 321.589 146.392 321.395 146.14 321.139C145.637 320.628 145.079 319.924 144.531 319.169C143.765 318.113 143.064 317.024 142.573 316.261C142.354 315.92 142.176 315.645 142.053 315.465Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.026 326.369C168.819 326.473 168.71 326.706 168.763 326.931C168.815 327.152 169.009 327.309 169.234 327.316C169.241 327.319 169.255 327.325 169.276 327.338C169.328 327.37 169.399 327.429 169.487 327.524C169.663 327.714 169.859 327.999 170.057 328.35C170.45 329.05 170.801 329.928 170.974 330.619C171.053 330.935 171.074 331.257 171.098 331.654C171.098 331.665 171.099 331.675 171.1 331.686C171.122 332.066 171.147 332.503 171.245 332.988C171.449 334.008 171.955 335.19 173.291 336.717C173.94 337.458 174.806 337.666 175.68 337.568C176.536 337.471 177.428 337.082 178.241 336.596C179.06 336.105 179.834 335.493 180.459 334.91C181.076 334.334 181.579 333.757 181.83 333.326C181.875 333.25 181.898 333.163 181.898 333.074C181.898 332.848 181.821 332.64 181.67 332.475C181.531 332.321 181.354 332.232 181.195 332.177C180.887 332.069 180.496 332.038 180.131 332.023C179.936 332.015 179.74 332.01 179.546 332.006C178.94 331.993 178.345 331.98 177.838 331.853C177.3 331.718 177.035 331.544 176.879 331.368C176.717 331.185 176.62 330.945 176.52 330.562C176.492 330.452 176.464 330.333 176.435 330.207C176.26 329.46 176.023 328.444 175.179 327.262C174.322 326.062 173.072 325.685 171.92 325.681C170.782 325.678 169.693 326.036 169.026 326.369Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.213 324.975H162.993V328.657C162.993 331.91 160.356 334.547 157.103 334.547C153.85 334.547 151.213 331.91 151.213 328.657V324.975Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9385 305.32C25.6794 304.255 25.581 302.85 26.4261 302.364C27.2327 301.9 27.4617 303.211 27.4787 304.476C27.8506 304.367 28.2619 304.324 28.7406 304.378C28.9293 303.215 29.2976 301.994 29.9123 302.16C30.5296 302.327 30.4772 303.644 30.2801 304.808C30.3944 304.856 30.5119 304.908 30.6326 304.964C31.075 305.171 31.4489 305.494 31.7554 305.874C34.8334 309.695 40.3939 316.344 41.2335 316.344H57.9829C58.3498 316.344 58.7146 316.396 59.0621 316.514C59.7483 316.747 60.594 317.073 61.3752 317.448C62.5233 317.999 63.5318 318.658 63.6895 319.289C63.7495 319.529 63.8879 319.877 64.0614 320.313C64.4011 321.167 64.8757 322.36 65.162 323.749C65.5687 325.721 65.5956 328.088 64.3162 330.438C63.9493 331.112 63.6895 331.85 63.6895 332.617V344.011C63.6895 344.996 62.891 345.794 61.9061 345.794H61.6248C60.4978 345.794 59.715 344.679 60.4496 343.825C60.7968 343.421 61.1126 342.897 61.1126 342.365V332.726C61.1126 332.014 60.5357 331.437 59.8241 331.437C59.1125 331.437 58.5356 332.014 58.5356 332.725V343.857C58.5356 344.927 57.6685 345.794 56.5988 345.794C55.3387 345.794 54.3849 344.592 54.9093 343.446C55.1267 342.971 55.3623 342.595 55.5906 342.481C56.0222 342.265 55.9531 338.346 55.7887 334.867C55.6974 332.934 54.0893 331.437 52.1544 331.437H43.4423C41.4092 331.437 39.761 333.085 39.761 335.118V343.804C39.761 344.903 38.87 345.794 37.7709 345.794C36.5151 345.794 35.5341 344.56 36.365 343.618C36.5011 343.464 36.6513 343.327 36.8159 343.217C37.4022 342.826 37.3725 342.198 37.1786 341.676C37.0036 341.204 36.5874 340.884 36.1812 340.588C35.0809 339.787 33.2036 338.112 31.294 335.486C29.0015 332.334 31.8395 330.074 33.557 328.707C34.0459 328.317 34.444 328 34.6071 327.756C35.0489 327.093 33.5028 324.045 31.9566 320.997C30.9259 318.965 29.8952 316.933 29.4534 315.607C28.9876 314.21 28.5013 313.843 28.0916 313.934C27.6297 314.036 27.2924 314.387 26.9517 314.741C26.6844 315.018 26.4151 315.298 26.082 315.462C23.5949 316.685 20.0166 318.202 19.5139 317.448C19.2815 317.1 19.0492 316.934 18.8631 316.802C18.4596 316.515 18.2737 316.383 18.7776 314.871C19.5139 312.662 22.0907 307.509 24.2995 306.404C24.8342 306.137 25.2827 305.805 25.7127 305.486C25.7884 305.43 25.8636 305.374 25.9385 305.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6699 334.148L36.1424 333.044V336.357L34.6699 334.148Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7436 308.526L23.0366 308.233C23.3498 307.92 23.3176 307.403 22.968 307.132L17 302.49L21.6418 308.458C21.9137 308.807 22.4304 308.84 22.7436 308.526Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0826 306.624C34.8067 306.222 34.2758 305.793 33.7143 305.426C33.138 305.049 32.4653 304.697 31.8505 304.469C31.4109 304.306 30.8957 304.303 30.4819 304.485C30.2701 304.578 30.0649 304.73 29.9273 304.955C29.7856 305.187 29.7392 305.46 29.7891 305.744C29.922 306.502 30.4773 307.411 31.1686 308.317C31.8763 309.245 32.7874 310.246 33.7249 311.196C35.5992 313.097 37.6175 314.837 38.4226 315.463C38.9146 315.845 39.3733 316.093 39.8351 316.192C40.3095 316.295 40.7428 316.232 41.1607 316.069C41.5635 315.913 41.9606 315.66 42.3698 315.38C42.5075 315.286 42.6467 315.189 42.7906 315.088C43.0897 314.879 43.409 314.656 43.7771 314.417C44.0602 314.234 44.2862 314.063 44.4309 313.899C44.5014 313.819 44.5883 313.702 44.6277 313.552C44.6751 313.371 44.6455 313.167 44.5077 313.002C44.3948 312.867 44.249 312.808 44.1579 312.78C44.0577 312.749 43.9523 312.734 43.8558 312.725C43.6621 312.709 43.4306 312.715 43.1928 312.731C42.7814 312.759 42.284 312.821 41.8074 312.881C41.7305 312.89 41.6542 312.9 41.5788 312.909C41.0189 312.978 40.5229 313.033 40.1923 313.033C40.1545 313.033 40.042 313.01 39.8391 312.875C39.6467 312.748 39.4212 312.554 39.1692 312.298C38.6662 311.787 38.108 311.082 37.5605 310.328C36.7939 309.271 36.0934 308.183 35.6023 307.42C35.3832 307.079 35.2057 306.803 35.0826 306.624Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0557 317.528C61.8483 317.632 61.7394 317.864 61.7927 318.09C61.8448 318.311 62.0385 318.468 62.2638 318.475C62.2703 318.477 62.2841 318.483 62.3058 318.497C62.3573 318.529 62.4284 318.588 62.5162 318.683C62.6921 318.873 62.8887 319.158 63.086 319.509C63.4796 320.208 63.8304 321.087 64.003 321.777C64.082 322.093 64.1036 322.416 64.127 322.813C64.1276 322.824 64.1282 322.834 64.1289 322.845C64.1512 323.225 64.1768 323.662 64.2739 324.147C64.4779 325.167 64.9847 326.349 66.3206 327.876C66.9694 328.617 67.8354 328.825 68.7098 328.726C69.5648 328.63 70.4572 328.241 71.2701 327.754C72.0893 327.264 72.8635 326.652 73.4884 326.069C74.1053 325.493 74.6084 324.916 74.8595 324.485C74.9041 324.409 74.9276 324.322 74.9276 324.233C74.9276 324.006 74.8501 323.799 74.6996 323.633C74.5601 323.48 74.3835 323.391 74.2247 323.335C73.9164 323.228 73.5257 323.197 73.16 323.181C72.9656 323.173 72.7697 323.169 72.5749 323.165C71.9697 323.151 71.3747 323.139 70.8676 323.012C70.3291 322.877 70.0642 322.703 69.9081 322.527C69.746 322.344 69.6488 322.104 69.5497 321.721C69.5212 321.61 69.4934 321.492 69.4639 321.365C69.2896 320.619 69.0521 319.602 68.2081 318.421C67.3513 317.221 66.1009 316.843 64.9497 316.84C63.8115 316.837 62.7221 317.195 62.0557 317.528Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2422 316.134H56.0224V319.815C56.0224 323.068 53.3853 325.705 50.1323 325.705C46.8793 325.705 44.2422 323.068 44.2422 319.815V316.134Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9385 333.609C86.6794 332.545 86.581 331.139 87.4261 330.653C88.2327 330.189 88.4617 331.501 88.4787 332.765C88.8506 332.657 89.2619 332.613 89.7406 332.667C89.9293 331.505 90.2976 330.284 90.9123 330.45C91.5296 330.616 91.4772 331.933 91.2801 333.097C91.3944 333.145 91.5119 333.197 91.6326 333.253C92.075 333.46 92.4489 333.784 92.7554 334.164C95.8334 337.984 101.394 344.633 102.233 344.633H118.983C119.35 344.633 119.715 344.686 120.062 344.804C120.748 345.037 121.594 345.362 122.375 345.737C123.523 346.289 124.532 346.948 124.689 347.578C124.75 347.818 124.888 348.166 125.061 348.602C125.401 349.456 125.876 350.65 126.162 352.038C126.569 354.011 126.596 356.378 125.316 358.728C124.949 359.402 124.689 360.139 124.689 360.906V372.3C124.689 373.285 123.891 374.084 122.906 374.084H122.625C121.498 374.084 120.715 372.969 121.45 372.114C121.797 371.71 122.113 371.187 122.113 370.654V361.015C122.113 360.303 121.536 359.726 120.824 359.726C120.113 359.726 119.536 360.303 119.536 361.015V372.147C119.536 373.216 118.668 374.084 117.599 374.084C116.339 374.084 115.385 372.881 115.909 371.735C116.127 371.26 116.362 370.885 116.591 370.77C117.022 370.555 116.953 366.636 116.789 363.156C116.697 361.224 115.089 359.726 113.154 359.726H104.442C102.409 359.726 100.761 361.375 100.761 363.408V372.094C100.761 373.193 99.87 374.084 98.7709 374.084C97.5151 374.084 96.5341 372.849 97.365 371.908C97.5011 371.753 97.6513 371.616 97.8159 371.507C98.4022 371.116 98.3725 370.487 98.1786 369.965C98.0036 369.494 97.5874 369.174 97.1812 368.878C96.0809 368.076 94.2036 366.402 92.294 363.776C90.0015 360.624 92.8395 358.364 94.557 356.996C95.0459 356.607 95.444 356.29 95.6071 356.045C96.0489 355.383 94.5028 352.334 92.9566 349.286C91.9259 347.254 90.8952 345.222 90.4534 343.897C89.9876 342.499 89.5013 342.132 89.0916 342.223C88.6297 342.326 88.2924 342.676 87.9517 343.03C87.6844 343.308 87.4151 343.588 87.082 343.751C84.5949 344.975 81.0166 346.492 80.5139 345.737C80.2815 345.389 80.0492 345.224 79.8631 345.091C79.4596 344.805 79.2737 344.672 79.7776 343.161C80.5139 340.952 83.0907 335.798 85.2995 334.694C85.8342 334.426 86.2827 334.094 86.7127 333.776C86.7884 333.72 86.8636 333.664 86.9385 333.609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6699 362.438L97.1424 361.334V364.647L95.6699 362.438Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7436 336.816L84.0366 336.523C84.3498 336.21 84.3176 335.693 83.968 335.421L78 330.779L82.6418 336.747C82.9137 337.097 83.4304 337.129 83.7436 336.816Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0826 334.914C95.8067 334.512 95.2758 334.082 94.7143 333.715C94.138 333.339 93.4653 332.987 92.8505 332.759C92.4109 332.595 91.8957 332.593 91.4819 332.775C91.2701 332.868 91.0649 333.019 90.9273 333.245C90.7856 333.477 90.7392 333.75 90.7891 334.034C90.922 334.791 91.4773 335.701 92.1686 336.607C92.8763 337.535 93.7874 338.535 94.7249 339.486C96.5992 341.386 98.6175 343.127 99.4226 343.753C99.9146 344.135 100.373 344.382 100.835 344.482C101.31 344.584 101.743 344.521 102.161 344.359C102.564 344.203 102.961 343.95 103.37 343.67C103.507 343.576 103.647 343.479 103.791 343.378C104.09 343.169 104.409 342.945 104.777 342.707C105.06 342.524 105.286 342.352 105.431 342.189C105.501 342.109 105.588 341.992 105.628 341.841C105.675 341.661 105.646 341.456 105.508 341.292C105.395 341.157 105.249 341.098 105.158 341.07C105.058 341.039 104.952 341.023 104.856 341.015C104.662 340.998 104.431 341.005 104.193 341.021C103.781 341.049 103.284 341.111 102.807 341.17C102.731 341.18 102.654 341.189 102.579 341.199C102.019 341.268 101.523 341.323 101.192 341.323C101.154 341.323 101.042 341.299 100.839 341.165C100.647 341.038 100.421 340.843 100.169 340.587C99.6662 340.076 99.108 339.372 98.5605 338.618C97.7939 337.561 97.0934 336.472 96.6023 335.709C96.3832 335.369 96.2057 335.093 96.0826 334.914Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.056 345.817C122.848 345.921 122.739 346.154 122.793 346.38C122.845 346.6 123.038 346.758 123.264 346.764C123.27 346.767 123.284 346.773 123.306 346.787C123.357 346.819 123.428 346.877 123.516 346.972C123.692 347.162 123.889 347.448 124.086 347.798C124.48 348.498 124.83 349.377 125.003 350.067C125.082 350.383 125.104 350.706 125.127 351.103C125.128 351.113 125.128 351.124 125.129 351.135C125.151 351.515 125.177 351.951 125.274 352.437C125.478 353.457 125.985 354.638 127.321 356.165C127.969 356.907 128.835 357.115 129.71 357.016C130.565 356.92 131.457 356.531 132.27 356.044C133.089 355.553 133.863 354.942 134.488 354.358C135.105 353.783 135.608 353.205 135.86 352.775C135.904 352.698 135.928 352.611 135.928 352.523C135.928 352.296 135.85 352.088 135.7 351.923C135.56 351.77 135.384 351.681 135.225 351.625C134.916 351.517 134.526 351.486 134.16 351.471C133.966 351.463 133.77 351.459 133.575 351.454C132.97 351.441 132.375 351.428 131.868 351.301C131.329 351.167 131.064 350.992 130.908 350.816C130.746 350.634 130.649 350.394 130.55 350.01C130.521 349.9 130.493 349.781 130.464 349.655C130.29 348.909 130.052 347.892 129.208 346.71C128.351 345.511 127.101 345.133 125.95 345.13C124.812 345.126 123.722 345.484 123.056 345.817Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.242 344.424H117.022V348.105C117.022 351.358 114.385 353.995 111.132 353.995C107.879 353.995 105.242 351.358 105.242 348.105V344.424Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.709 276.534C106.741 277.697 104.955 277.697 103.987 276.534L99.2176 270.812L112.479 270.812L107.709 276.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1886 223.698C99.7389 223.321 100.464 223.321 101.015 223.698L165.471 267.864C166.78 268.761 166.145 270.812 164.558 270.812H35.6455C34.0579 270.812 33.4229 268.761 34.7325 267.864L99.1886 223.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.102 223.957L143.42 270.812H126.951L100.102 223.957Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2178 223.957L70.769 270.812H54.1309L99.2178 223.957Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6596 223.073L107.699 270.812H91.6206L99.6596 223.073Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 57,
    width: 169,
    height: 79,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_4896_21522)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 96,
    width: 171,
    height: 3,
    fill: "#22343C"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 117,
    width: 174,
    height: 22,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.685 22.3986C293.304 22.1356 293.969 22 294.642 22H302.358C303.031 22 303.696 22.1356 304.315 22.3986L358.415 45.3986C363.427 47.529 361.905 55 356.459 55H240.541C235.095 55 233.573 47.529 238.585 45.3986L292.685 22.3986Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.742 25.4144C300.227 25.7948 299.603 26 298.962 26L298.038 26C297.397 26 296.773 25.7948 296.258 25.4144L281.342 14.4144C279.012 12.696 280.227 9 283.122 9L313.878 9C316.773 9 317.988 12.696 315.658 14.4144L300.742 25.4144Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.742 45.4144C363.227 45.7948 362.603 46 361.962 46L361.038 46C360.397 46 359.773 45.7948 359.258 45.4144L344.342 34.4144C342.012 32.696 343.227 29 346.122 29L376.878 29C379.773 29 380.988 32.696 378.658 34.4144L363.742 45.4144Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.742 45.4144C237.227 45.7948 236.603 46 235.962 46L235.038 46C234.397 46 233.773 45.7948 233.258 45.4144L218.342 34.4144C216.012 32.696 217.227 29 220.122 29L250.878 29C253.773 29 254.988 32.696 252.658 34.4144L237.742 45.4144Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-323-outside-7_4896_21522",
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 44,
    width: 202,
    height: 135,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 199,
    y: 44,
    width: 202,
    height: 135
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399 51C399 48.2386 396.761 46 394 46H206C203.239 46 201 48.2386 201 51V172C201 174.761 203.239 177 206 177H394C396.761 177 399 174.761 399 172V51ZM382.565 61C382.565 58.2386 380.326 56 377.565 56H220.435C217.674 56 215.435 58.2386 215.435 61V130C215.435 132.761 217.674 135 220.435 135H377.565C380.326 135 382.565 132.761 382.565 130V61Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399 51C399 48.2386 396.761 46 394 46H206C203.239 46 201 48.2386 201 51V172C201 174.761 203.239 177 206 177H394C396.761 177 399 174.761 399 172V51ZM382.565 61C382.565 58.2386 380.326 56 377.565 56H220.435C217.674 56 215.435 58.2386 215.435 61V130C215.435 132.761 217.674 135 220.435 135H377.565C380.326 135 382.565 132.761 382.565 130V61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 48H394V44H206V48ZM203 172V51H199V172H203ZM394 175H206V179H394V175ZM397 51V172H401V51H397ZM220.435 58H377.565V54H220.435V58ZM217.435 130V61H213.435V130H217.435ZM377.565 133H220.435V137H377.565V133ZM380.565 61V130H384.565V61H380.565ZM377.565 137C381.431 137 384.565 133.866 384.565 130H380.565C380.565 131.657 379.222 133 377.565 133V137ZM213.435 130C213.435 133.866 216.569 137 220.435 137V133C218.778 133 217.435 131.657 217.435 130H213.435ZM377.565 58C379.222 58 380.565 59.3431 380.565 61H384.565C384.565 57.134 381.431 54 377.565 54V58ZM220.435 54C216.569 54 213.435 57.134 213.435 61H217.435C217.435 59.3431 218.778 58 220.435 58V54ZM394 179C397.866 179 401 175.866 401 172H397C397 173.657 395.657 175 394 175V179ZM199 172C199 175.866 202.134 179 206 179V175C204.343 175 203 173.657 203 172H199ZM394 48C395.657 48 397 49.3431 397 51H401C401 47.134 397.866 44 394 44V48ZM206 44C202.134 44 199 47.134 199 51H203C203 49.3431 204.343 48 206 48V44Z",
    fill: "black",
    mask: "url(#path-323-outside-7_4896_21522)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.621 29.4092C294.246 29.1392 294.92 29 295.602 29H301.398C302.08 29 302.754 29.1392 303.379 29.4092L342.775 46.4092C347.761 48.5608 346.224 56 340.794 56H256.206C250.776 56 249.239 48.5608 254.225 46.4092L293.621 29.4092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 56.5,
    width: 169,
    height: 79,
    rx: 2.5,
    stroke: "#1E1E1E",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 37.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.5,
    cy: 15.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.5,
    cy: 37.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 76.8532,
    r: 8.3533,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.844,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.896,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.154,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.103,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.999,
    cy: 87.1726,
    rx: 11.3015,
    ry: 9.82742,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.999,
    cy: 86.1889,
    rx: 7.37056,
    ry: 5.89645,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.861,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.137,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 361.103 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 372.896 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.473,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.524,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.998,
    cy: 76.854,
    rx: 3.4396,
    ry: 2.45685,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.93 77.6956C367.516 78.4131 366.48 78.4131 366.066 77.6956L365.803 77.2393C365.388 76.5217 365.906 75.6248 366.735 75.6248L367.262 75.6248C368.09 75.6248 368.608 76.5217 368.194 77.2393L367.93 77.6956Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.303,
    cy: 76.8532,
    r: 8.3533,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.146,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.199,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.457,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.406,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.302,
    cy: 87.1726,
    rx: 11.3015,
    ry: 9.82742,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.302,
    cy: 86.1889,
    rx: 7.37056,
    ry: 5.89645,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.164,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.439,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 335.406 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 347.199 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.776,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.826,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.301,
    cy: 76.854,
    rx: 3.4396,
    ry: 2.45685,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.233 77.6956C341.819 78.4131 340.783 78.4131 340.369 77.6956L340.105 77.2393C339.691 76.5217 340.209 75.6248 341.038 75.6248L341.564 75.6248C342.393 75.6248 342.911 76.5217 342.497 77.2393L342.233 77.6956Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.303,
    cy: 76.8532,
    r: 8.3533,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.146,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.199,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.457,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.406,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.302,
    cy: 87.1726,
    rx: 11.3015,
    ry: 9.82742,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.302,
    cy: 86.1889,
    rx: 7.37056,
    ry: 5.89645,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.164,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.439,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 308.406 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 320.199 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.776,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.826,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.301,
    cy: 76.854,
    rx: 3.4396,
    ry: 2.45685,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.233 77.6956C314.819 78.4131 313.783 78.4131 313.369 77.6956L313.105 77.2393C312.691 76.5217 313.209 75.6248 314.038 75.6248L314.564 75.6248C315.393 75.6248 315.911 76.5217 315.497 77.2393L315.233 77.6956Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.303,
    cy: 76.8532,
    r: 8.3533,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.146,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.199,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.457,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.406,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.302,
    cy: 87.1726,
    rx: 11.3015,
    ry: 9.82742,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.302,
    cy: 86.1889,
    rx: 7.37056,
    ry: 5.89645,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.164,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.439,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 279.406 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 291.199 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.776,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.826,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.301,
    cy: 76.854,
    rx: 3.4396,
    ry: 2.45685,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.233 77.6956C285.819 78.4131 284.783 78.4131 284.369 77.6956L284.105 77.2393C283.691 76.5217 284.209 75.6248 285.038 75.6248L285.564 75.6248C286.393 75.6248 286.911 76.5217 286.497 77.2393L286.233 77.6956Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.303,
    cy: 76.8532,
    r: 8.3533,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.146,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.199,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.457,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.406,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.302,
    cy: 87.1726,
    rx: 11.3015,
    ry: 9.82742,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.302,
    cy: 86.1889,
    rx: 7.37056,
    ry: 5.89645,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.164,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.439,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 253.406 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 265.199 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.776,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.826,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.301,
    cy: 76.854,
    rx: 3.4396,
    ry: 2.45685,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.233 77.6956C259.819 78.4131 258.783 78.4131 258.369 77.6956L258.105 77.2393C257.691 76.5217 258.209 75.6248 259.038 75.6248L259.564 75.6248C260.393 75.6248 260.911 76.5217 260.497 77.2393L260.233 77.6956Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.303,
    cy: 76.8532,
    r: 8.3533,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.146,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.199,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.457,
    cy: 82.7493,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.406,
    cy: 69.9743,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.302,
    cy: 87.1726,
    rx: 11.3015,
    ry: 9.82742,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.302,
    cy: 86.1889,
    rx: 7.37056,
    ry: 5.89645,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.164,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.439,
    cy: 94.5429,
    r: 2.45685,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 227.406 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.47411,
    transform: "matrix(1 0 0 -1 239.199 69.9749)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.776,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.826,
    cy: 74.3966,
    r: 0.982742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.301,
    cy: 76.854,
    rx: 3.4396,
    ry: 2.45685,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.233 77.6956C233.819 78.4131 232.783 78.4131 232.369 77.6956L232.105 77.2393C231.691 76.5217 232.209 75.6248 233.038 75.6248L233.564 75.6248C234.393 75.6248 234.911 76.5217 234.497 77.2393L234.233 77.6956Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.5,
    y: 118.5,
    width: 9,
    height: 12,
    rx: 2.5,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.5,
    y: 111.5,
    width: 5,
    height: 14,
    rx: 1.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 111,
    r: 4.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 118.5,
    width: 9,
    height: 12,
    rx: 2.5,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 111.5,
    width: 5,
    height: 14,
    rx: 1.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 111,
    r: 4.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.5,
    y: 118.5,
    width: 9,
    height: 12,
    rx: 2.5,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.5,
    y: 111.5,
    width: 5,
    height: 14,
    rx: 1.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 111,
    r: 4.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.5,
    y: 118.5,
    width: 9,
    height: 12,
    rx: 2.5,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.5,
    y: 111.5,
    width: 5,
    height: 14,
    rx: 1.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 111,
    r: 4.5,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M866.6 51.5712C861.758 56.1748 855.209 59 848 59C840.682 59 834.045 56.0889 829.182 51.3617C826.88 53.0218 824.054 54 821 54C813.268 54 807 47.732 807 40C807 32.268 813.268 26 821 26C821.223 26 821.445 26.0052 821.666 26.0155C824.388 13.9838 835.145 5 848 5C858.351 5 867.342 10.8252 871.873 19.3763C873.043 19.1297 874.257 19 875.5 19C885.165 19 893 26.835 893 36.5C893 46.165 885.165 54 875.5 54C872.25 54 869.208 53.1143 866.6 51.5712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.6 89.5712C458.758 94.1748 452.209 97 445 97C437.682 97 431.045 94.0889 426.182 89.3617C423.88 91.0218 421.054 92 418 92C410.268 92 404 85.732 404 78C404 70.268 410.268 64 418 64C418.223 64 418.445 64.0052 418.666 64.0155C421.388 51.9838 432.145 43 445 43C455.351 43 464.342 48.8252 468.873 57.3763C470.043 57.1297 471.257 57 472.5 57C482.165 57 490 64.835 490 74.5C490 84.165 482.165 92 472.5 92C469.25 92 466.208 91.1143 463.6 89.5712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-434-inside-8_4896_21522",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.135 759.088C188.664 748.303 183.203 738.33 175.253 730.381C164.125 719.252 149.031 713 133.292 713C117.553 713 102.46 719.252 91.3307 730.381C87.1112 734.6 83.5927 739.39 80.8503 744.569C72.8147 740.072 63.6927 737.65 54.3211 737.65C39.9142 737.65 26.0975 743.373 15.9103 753.56C6.26234 763.208 0.618395 776.112 0.0479208 789.689H0V791.971V799.731H472V791.971V789.689H471.867C471.356 785.323 469.39 781.23 466.251 778.091C462.57 774.41 457.577 772.342 452.371 772.342C447.531 772.342 442.875 774.13 439.286 777.34C436.58 768.698 431.815 760.75 425.294 754.229C414.678 743.613 400.281 737.65 385.269 737.65C370.257 737.65 355.859 743.613 345.244 754.229C340.086 759.387 336.026 765.438 333.215 772.019C332.114 770.528 330.897 769.112 329.57 767.785C322.551 760.766 313.03 756.822 303.103 756.822C293.175 756.822 283.654 760.766 276.635 767.785C274.113 770.307 271.989 773.151 270.301 776.221C267.611 774.883 264.624 774.168 261.563 774.168C259.86 774.168 258.179 774.39 256.56 774.816C254.464 770.58 251.677 766.672 248.271 763.267C240.053 755.048 228.907 750.431 217.284 750.431C207.809 750.431 198.649 753.5 191.135 759.088Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.135 759.088C188.664 748.303 183.203 738.33 175.253 730.381C164.125 719.252 149.031 713 133.292 713C117.553 713 102.46 719.252 91.3307 730.381C87.1112 734.6 83.5927 739.39 80.8503 744.569C72.8147 740.072 63.6927 737.65 54.3211 737.65C39.9142 737.65 26.0975 743.373 15.9103 753.56C6.26234 763.208 0.618395 776.112 0.0479208 789.689H0V791.971V799.731H472V791.971V789.689H471.867C471.356 785.323 469.39 781.23 466.251 778.091C462.57 774.41 457.577 772.342 452.371 772.342C447.531 772.342 442.875 774.13 439.286 777.34C436.58 768.698 431.815 760.75 425.294 754.229C414.678 743.613 400.281 737.65 385.269 737.65C370.257 737.65 355.859 743.613 345.244 754.229C340.086 759.387 336.026 765.438 333.215 772.019C332.114 770.528 330.897 769.112 329.57 767.785C322.551 760.766 313.03 756.822 303.103 756.822C293.175 756.822 283.654 760.766 276.635 767.785C274.113 770.307 271.989 773.151 270.301 776.221C267.611 774.883 264.624 774.168 261.563 774.168C259.86 774.168 258.179 774.39 256.56 774.816C254.464 770.58 251.677 766.672 248.271 763.267C240.053 755.048 228.907 750.431 217.284 750.431C207.809 750.431 198.649 753.5 191.135 759.088Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.253 730.381L176.668 728.967V728.967L175.253 730.381ZM191.135 759.088L189.186 759.534L189.87 762.521L192.329 760.693L191.135 759.088ZM91.3307 730.381L89.9165 728.967V728.967L91.3307 730.381ZM80.8503 744.569L79.8736 746.314L81.6598 747.313L82.6177 745.505L80.8503 744.569ZM54.3211 737.65V739.65V737.65ZM15.9103 753.56L17.3245 754.974H17.3245L15.9103 753.56ZM0.0479208 789.689V791.689H1.96565L2.04616 789.773L0.0479208 789.689ZM0 789.689V787.689H-2V789.689H0ZM0 799.731H-2V801.731H0V799.731ZM472 799.731V801.731H474V799.731H472ZM472 789.689H474V787.689H472V789.689ZM471.867 789.689L469.88 789.921L470.087 791.689H471.867V789.689ZM466.251 778.091L464.837 779.506V779.506L466.251 778.091ZM439.286 777.34L437.378 777.938L438.306 780.9L440.62 778.831L439.286 777.34ZM425.294 754.229L423.879 755.643V755.643L425.294 754.229ZM345.244 754.229L343.83 752.814L345.244 754.229ZM333.215 772.019L331.606 773.207L333.682 776.018L335.054 772.805L333.215 772.019ZM329.57 767.785L328.156 769.2V769.2L329.57 767.785ZM276.635 767.785L275.22 766.371V766.371L276.635 767.785ZM270.301 776.221L269.411 778.012L271.129 778.866L272.054 777.184L270.301 776.221ZM256.56 774.816L254.768 775.704L255.491 777.166L257.07 776.75L256.56 774.816ZM248.271 763.267L249.685 761.852L248.271 763.267ZM173.839 731.795C181.521 739.476 186.798 749.113 189.186 759.534L193.085 758.641C190.53 747.492 184.885 737.184 176.668 728.967L173.839 731.795ZM133.292 715C148.5 715 163.085 721.041 173.839 731.795L176.668 728.967C165.164 717.463 149.561 711 133.292 711V715ZM92.7449 731.795C103.499 721.041 118.084 715 133.292 715V711C117.023 711 101.42 717.463 89.9165 728.967L92.7449 731.795ZM82.6177 745.505C85.2677 740.501 88.6675 735.873 92.7449 731.795L89.9165 728.967C85.5548 733.328 81.9177 738.279 79.0828 743.633L82.6177 745.505ZM54.3211 739.65C63.3476 739.65 72.1337 741.982 79.8736 746.314L81.827 742.823C73.4957 738.161 64.0378 735.65 54.3211 735.65V739.65ZM17.3245 754.974C27.1366 745.162 40.4447 739.65 54.3211 739.65V735.65C39.3838 735.65 25.0583 741.584 14.4961 752.146L17.3245 754.974ZM2.04616 789.773C2.59562 776.695 8.03179 764.267 17.3245 754.974L14.4961 752.146C4.49289 762.149 -1.35883 775.528 -1.95032 789.605L2.04616 789.773ZM0 791.689H0.0479208V787.689H0V791.689ZM2 791.971V789.689H-2V791.971H2ZM2 799.731V791.971H-2V799.731H2ZM472 797.731H0V801.731H472V797.731ZM470 791.971V799.731H474V791.971H470ZM470 789.689V791.971H474V789.689H470ZM471.867 791.689H472V787.689H471.867V791.689ZM464.837 779.506C467.656 782.325 469.422 786.001 469.88 789.921L473.853 789.456C473.29 784.646 471.124 780.136 467.665 776.677L464.837 779.506ZM452.371 774.342C457.047 774.342 461.531 776.2 464.837 779.506L467.665 776.677C463.609 772.621 458.108 770.342 452.371 770.342V774.342ZM440.62 778.831C443.843 775.948 448.024 774.342 452.371 774.342V770.342C447.038 770.342 441.908 772.312 437.953 775.849L440.62 778.831ZM423.879 755.643C430.17 761.934 434.767 769.601 437.378 777.938L441.195 776.742C438.393 767.796 433.459 759.566 426.708 752.814L423.879 755.643ZM385.269 739.65C399.751 739.65 413.639 745.403 423.879 755.643L426.708 752.814C415.717 741.824 400.811 735.65 385.269 735.65V739.65ZM346.658 755.643C356.899 745.403 370.787 739.65 385.269 739.65V735.65C369.726 735.65 354.82 741.824 343.83 752.814L346.658 755.643ZM335.054 772.805C337.766 766.456 341.682 760.619 346.658 755.643L343.83 752.814C338.489 758.155 334.286 764.42 331.376 771.234L335.054 772.805ZM328.156 769.2C329.412 770.456 330.564 771.796 331.606 773.207L334.824 770.831C333.664 769.26 332.382 767.769 330.985 766.371L328.156 769.2ZM303.103 758.822C312.499 758.822 321.512 762.555 328.156 769.2L330.985 766.371C323.59 758.976 313.56 754.822 303.103 754.822V758.822ZM278.049 769.2C284.693 762.555 293.706 758.822 303.103 758.822V754.822C292.645 754.822 282.615 758.976 275.22 766.371L278.049 769.2ZM272.054 777.184C273.651 774.278 275.662 771.586 278.049 769.2L275.22 766.371C272.564 769.027 270.326 772.023 268.548 775.257L272.054 777.184ZM261.563 776.168C264.312 776.168 266.995 776.81 269.411 778.012L271.191 774.43C268.227 772.956 264.936 772.168 261.563 772.168V776.168ZM257.07 776.75C258.524 776.367 260.033 776.168 261.563 776.168V772.168C259.686 772.168 257.834 772.412 256.05 772.883L257.07 776.75ZM246.857 764.681C250.107 767.931 252.767 771.66 254.768 775.704L258.353 773.929C256.16 769.5 253.246 765.413 249.685 761.852L246.857 764.681ZM217.284 752.431C228.376 752.431 239.014 756.838 246.857 764.681L249.685 761.852C241.092 753.259 229.437 748.431 217.284 748.431V752.431ZM192.329 760.693C199.5 755.36 208.241 752.431 217.284 752.431V748.431C207.376 748.431 197.799 751.64 189.942 757.483L192.329 760.693Z",
    fill: "white",
    mask: "url(#path-434-inside-8_4896_21522)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5648,
    height: 7.30368,
    rx: 1.82592,
    transform: "matrix(-0.999852 0.0171872 0.0171872 0.999852 363.82 697.141)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-437-outside-9_4896_21522",
    maskUnits: "userSpaceOnUse",
    x: 339.07,
    y: 698.721,
    width: 34.27,
    height: 16.582,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 339.07,
    y: 698.721,
    width: 34.27,
    height: 16.582
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.531 701.176C363.519 700.463 364.086 699.876 364.799 699.864L365.39 699.853C369.086 699.79 372.134 702.735 372.197 706.431C372.261 710.127 369.316 713.174 365.62 713.238L347.968 713.541C344.272 713.605 341.225 710.66 341.161 706.964C341.098 703.268 344.042 700.22 347.738 700.157C348.382 700.146 348.912 700.659 348.923 701.302L348.926 701.427C348.938 702.139 349.525 702.707 350.238 702.695L362.263 702.488C362.975 702.476 363.543 701.888 363.531 701.176Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.531 701.176C363.519 700.463 364.086 699.876 364.799 699.864L365.39 699.853C369.086 699.79 372.134 702.735 372.197 706.431C372.261 710.127 369.316 713.174 365.62 713.238L347.968 713.541C344.272 713.605 341.225 710.66 341.161 706.964C341.098 703.268 344.042 700.22 347.738 700.157C348.382 700.146 348.912 700.659 348.923 701.302L348.926 701.427C348.938 702.139 349.525 702.707 350.238 702.695L362.263 702.488C362.975 702.476 363.543 701.888 363.531 701.176Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.39 699.853L365.373 698.854L365.39 699.853ZM365.62 713.238L365.603 712.238L365.62 713.238ZM347.968 713.541L347.985 714.541L347.968 713.541ZM348.926 701.427L347.926 701.444L348.926 701.427ZM348.923 701.302L349.923 701.285L348.923 701.302ZM365.407 700.853L364.816 700.863L364.781 698.864L365.373 698.854L365.407 700.853ZM371.197 706.448C371.143 703.304 368.551 700.799 365.407 700.853L365.373 698.854C369.621 698.781 373.124 702.165 373.197 706.413L371.197 706.448ZM365.603 712.238C368.747 712.184 371.251 709.592 371.197 706.448L373.197 706.413C373.27 710.662 369.885 714.165 365.637 714.238L365.603 712.238ZM347.951 712.541L365.603 712.238L365.637 714.238L347.985 714.541L347.951 712.541ZM342.161 706.947C342.215 710.091 344.807 712.595 347.951 712.541L347.985 714.541C343.737 714.614 340.234 711.229 340.161 706.981L342.161 706.947ZM347.755 701.157C344.612 701.211 342.107 703.803 342.161 706.947L340.161 706.981C340.088 702.733 343.473 699.23 347.721 699.157L347.755 701.157ZM349.923 701.285L349.925 701.41L347.926 701.444L347.924 701.319L349.923 701.285ZM350.221 701.695L362.246 701.488L362.28 703.488L350.255 703.694L350.221 701.695ZM362.246 701.488C362.406 701.485 362.534 701.353 362.531 701.193L364.531 701.159C364.552 702.423 363.545 703.466 362.28 703.488L362.246 701.488ZM349.925 701.41C349.928 701.57 350.06 701.697 350.221 701.695L350.255 703.694C348.99 703.716 347.948 702.709 347.926 701.444L349.925 701.41ZM347.721 699.157C348.917 699.136 349.903 700.089 349.923 701.285L347.924 701.319C347.922 701.228 347.847 701.155 347.755 701.157L347.721 699.157ZM364.816 700.863C364.656 700.866 364.528 700.998 364.531 701.159L362.531 701.193C362.509 699.928 363.517 698.885 364.781 698.864L364.816 700.863Z",
    fill: "white",
    mask: "url(#path-437-outside-9_4896_21522)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.82592,
    transform: "matrix(-0.999852 0.0171872 0.0171872 0.999852 363.19 713.588)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.82592,
    transform: "matrix(-0.999852 0.0171872 0.0171872 0.999852 349.497 713.823)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.461 707.993C342.47 703.444 344.888 702.489 345.641 702.02C346.995 701.084 348.468 703.04 346.586 703.83C344.319 704.782 346.026 706.416 345.287 707.961C344.846 708.881 343.626 708.751 343.461 707.993Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5648,
    height: 7.30368,
    rx: 1.82592,
    transform: "matrix(-0.999826 0.0186353 0.0186353 0.999826 331.82 697.153)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-443-inside-10_4896_21522",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.536 701.188C331.523 700.476 332.09 699.887 332.802 699.874L333.394 699.863C337.09 699.794 340.142 702.734 340.211 706.43C340.28 710.126 337.339 713.178 333.643 713.247L315.992 713.576C312.296 713.645 309.244 710.705 309.175 707.009C309.107 703.313 312.047 700.261 315.743 700.192C316.386 700.18 316.917 700.692 316.929 701.335L316.931 701.46C316.945 702.173 317.533 702.74 318.246 702.727L330.27 702.502C330.983 702.489 331.55 701.901 331.536 701.188Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.536 701.188C331.523 700.476 332.09 699.887 332.802 699.874L333.394 699.863C337.09 699.794 340.142 702.734 340.211 706.43C340.28 710.126 337.339 713.178 333.643 713.247L315.992 713.576C312.296 713.645 309.244 710.705 309.175 707.009C309.107 703.313 312.047 700.261 315.743 700.192C316.386 700.18 316.917 700.692 316.929 701.335L316.931 701.46C316.945 702.173 317.533 702.74 318.246 702.727L330.27 702.502C330.983 702.489 331.55 701.901 331.536 701.188Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.394 699.863L333.375 698.863L333.394 699.863ZM333.413 700.863L332.821 700.874L332.784 698.874L333.375 698.863L333.413 700.863ZM339.211 706.449C339.152 703.305 336.556 700.804 333.413 700.863L333.375 698.863C337.623 698.784 341.131 702.164 341.21 706.412L339.211 706.449ZM333.625 712.247C336.768 712.189 339.269 709.593 339.211 706.449L341.21 706.412C341.29 710.66 337.91 714.168 333.662 714.247L333.625 712.247ZM315.974 712.576L333.625 712.247L333.662 714.247L316.011 714.576L315.974 712.576ZM310.175 706.99C310.234 710.134 312.83 712.635 315.974 712.576L316.011 714.576C311.763 714.655 308.255 711.275 308.176 707.027L310.175 706.99ZM315.761 701.192C312.618 701.25 310.117 703.846 310.175 706.99L308.176 707.027C308.096 702.779 311.476 699.271 315.724 699.192L315.761 701.192ZM317.929 701.316L317.931 701.442L315.932 701.479L315.929 701.354L317.929 701.316ZM318.227 701.727L330.251 701.503L330.289 703.502L318.264 703.726L318.227 701.727ZM330.251 701.503C330.412 701.5 330.539 701.367 330.536 701.207L332.536 701.17C332.56 702.434 331.553 703.479 330.289 703.502L330.251 701.503ZM317.931 701.442C317.934 701.602 318.067 701.73 318.227 701.727L318.264 703.726C317 703.75 315.955 702.744 315.932 701.479L317.931 701.442ZM315.724 699.192C316.919 699.17 317.907 700.121 317.929 701.316L315.929 701.354C315.928 701.263 315.852 701.19 315.761 701.192L315.724 699.192ZM332.821 700.874C332.661 700.877 332.533 701.009 332.536 701.17L330.536 701.207C330.513 699.942 331.519 698.898 332.784 698.874L332.821 700.874Z",
    fill: "white",
    mask: "url(#path-443-inside-10_4896_21522)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.82592,
    transform: "matrix(-0.999826 0.0186353 0.0186353 0.999826 331.214 713.6)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.82592,
    transform: "matrix(-0.999826 0.0186353 0.0186353 0.999826 317.521 713.855)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.478 708.034C310.48 703.486 312.897 702.529 313.65 702.058C315.002 701.12 316.477 703.073 314.596 703.867C312.332 704.822 314.041 706.453 313.304 707.999C312.864 708.921 311.644 708.792 311.478 708.034Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5648,
    height: 7.30368,
    rx: 1.82592,
    transform: "matrix(-0.814185 -0.580606 -0.580606 0.814185 398.186 712.252)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-449-inside-11_4896_21522",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.555 715.324C395.968 714.744 396.774 714.609 397.354 715.023L397.836 715.366C400.845 717.512 401.545 721.692 399.399 724.702C397.253 727.711 393.073 728.411 390.063 726.265L375.69 716.015C372.68 713.869 371.98 709.689 374.126 706.679C376.272 703.67 380.452 702.97 383.462 705.116C383.986 705.49 384.108 706.217 383.734 706.741L383.662 706.843C383.248 707.423 383.383 708.229 383.963 708.643L393.755 715.626C394.335 716.039 395.141 715.904 395.555 715.324Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.555 715.324C395.968 714.744 396.774 714.609 397.354 715.023L397.836 715.366C400.845 717.512 401.545 721.692 399.399 724.702C397.253 727.711 393.073 728.411 390.063 726.265L375.69 716.015C372.68 713.869 371.98 709.689 374.126 706.679C376.272 703.67 380.452 702.97 383.462 705.116C383.986 705.49 384.108 706.217 383.734 706.741L383.662 706.843C383.248 707.423 383.383 708.229 383.963 708.643L393.755 715.626C394.335 716.039 395.141 715.904 395.555 715.324Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.755 715.626L393.174 716.44L393.755 715.626ZM383.662 706.843L384.476 707.424L383.662 706.843ZM383.963 708.643L383.382 709.457L383.963 708.643ZM383.734 706.741L382.92 706.161L383.734 706.741ZM397.255 716.18L396.774 715.837L397.935 714.209L398.416 714.552L397.255 716.18ZM398.585 724.121C400.41 721.561 399.815 718.006 397.255 716.18L398.416 714.552C401.876 717.019 402.68 721.823 400.213 725.282L398.585 724.121ZM390.644 725.451C393.204 727.277 396.759 726.681 398.585 724.121L400.213 725.282C397.746 728.742 392.942 729.546 389.483 727.079L390.644 725.451ZM376.27 715.201L390.644 725.451L389.483 727.079L375.109 716.829L376.27 715.201ZM374.94 707.26C373.115 709.82 373.71 713.375 376.27 715.201L375.109 716.829C371.65 714.362 370.845 709.558 373.312 706.099L374.94 707.26ZM382.881 705.93C380.321 704.105 376.766 704.7 374.94 707.26L373.312 706.099C375.779 702.64 380.583 701.835 384.042 704.302L382.881 705.93ZM384.548 707.322L384.476 707.424L382.847 706.262L382.92 706.161L384.548 707.322ZM384.543 707.828L394.336 714.811L393.174 716.44L383.382 709.457L384.543 707.828ZM394.336 714.811C394.466 714.904 394.647 714.874 394.74 714.744L396.369 715.905C395.634 716.935 394.204 717.174 393.174 716.44L394.336 714.811ZM384.476 707.424C384.383 707.554 384.413 707.735 384.543 707.828L383.382 709.457C382.352 708.722 382.113 707.292 382.847 706.262L384.476 707.424ZM384.042 704.302C385.016 704.996 385.243 706.348 384.548 707.322L382.92 706.161C382.973 706.086 382.956 705.983 382.881 705.93L384.042 704.302ZM396.774 715.837C396.643 715.744 396.462 715.774 396.369 715.905L394.74 714.744C395.475 713.714 396.905 713.474 397.935 714.209L396.774 715.837Z",
    fill: "white",
    mask: "url(#path-449-inside-11_4896_21522)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.82592,
    transform: "matrix(-0.814185 -0.580606 -0.580606 0.814185 387.9 725.101)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.82592,
    transform: "matrix(-0.814185 -0.580606 -0.580606 0.814185 376.75 717.15)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.365 708.874C377.272 704.627 379.785 705.297 380.669 705.367C382.314 705.419 382.336 707.867 380.352 707.384C377.964 706.802 378.365 709.131 376.852 709.933C375.95 710.412 375.048 709.581 375.365 708.874Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4896_21522",
    x: 806.781,
    y: 616.559,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4896_21522",
    x: 738.166,
    y: 646.44,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4896_21522",
    x: 668.445,
    y: 618.772,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_4896_21522",
    x: 629.711,
    y: 570.078,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_4896_21522",
    x: 629.711,
    y: 494.823,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.979463
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_4896_21522",
    x: 668.445,
    y: 439.488,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_4896_21522",
    x: 843.303,
    y: 501.463,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_4896_21522",
    x: 843.301,
    y: 570.078,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_4896_21522",
    x: 806.781,
    y: 441.702,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_4896_21522",
    x: 738.166,
    y: 417.356,
    width: 24.0703,
    height: 18.4098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979463
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4896_21522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_4896_21522",
    x: 211,
    y: 95,
    width: 175,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4896_21522"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4896_21522",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4896_21522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmusementParkContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmusementParkContrast.05b1d3b9804a811d415228f065e9850e.svg";